/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Error {
  data?: object | object[] | null;
  error: {
    status?: number;
    name?: string;
    message?: string;
    details?: object;
  };
}

export interface BannerPromoLocalizationRequest {
  priority?: number;
  /** @format date-time */
  date_start?: string;
  /** @format date-time */
  date_end?: string;
  title?: string;
  body?: any;
  /** @example "string or id" */
  media?: number | string;
  linkUrl: string;
  backgroundDimming?: boolean;
  locale: string;
}

export interface BannerPromoRequest {
  data: {
    priority?: number;
    /** @format date-time */
    date_start?: string;
    /** @format date-time */
    date_end?: string;
    title?: string;
    body?: any;
    /** @example "string or id" */
    media?: number | string;
    linkUrl: string;
    backgroundDimming?: boolean;
    locale?: string;
  };
}

export interface BannerPromoResponseDataObjectLocalized {
  id?: number;
  attributes?: BannerPromo;
}

export interface BannerPromoLocalizationResponse {
  data?: BannerPromoResponseDataObjectLocalized;
  meta?: object;
}

export interface BannerPromoListResponseDataItemLocalized {
  id?: number;
  attributes?: BannerPromo;
}

export interface BannerPromoLocalizationListResponse {
  data?: BannerPromoListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface BannerPromoListResponseDataItem {
  id?: number;
  attributes?: BannerPromo;
}

export interface BannerPromoListResponse {
  data?: BannerPromoListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface BannerPromo {
  priority?: number;
  /** @format date-time */
  date_start?: string;
  /** @format date-time */
  date_end?: string;
  title?: string;
  body?: any;
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              pathId?: number;
              parent?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              children?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              files?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: {
                          firstname?: string;
                          lastname?: string;
                          username?: string;
                          /** @format email */
                          email?: string;
                          resetPasswordToken?: string;
                          registrationToken?: string;
                          isActive?: boolean;
                          roles?: {
                            data?: {
                              id?: number;
                              attributes?: {
                                name?: string;
                                code?: string;
                                description?: string;
                                users?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  }[];
                                };
                                permissions?: {
                                  data?: {
                                    id?: number;
                                    attributes?: {
                                      action?: string;
                                      actionParameters?: any;
                                      subject?: string;
                                      properties?: any;
                                      conditions?: any;
                                      role?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      /** @format date-time */
                                      createdAt?: string;
                                      /** @format date-time */
                                      updatedAt?: string;
                                      createdBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      updatedBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                    };
                                  }[];
                                };
                                /** @format date-time */
                                createdAt?: string;
                                /** @format date-time */
                                updatedAt?: string;
                                createdBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                                updatedBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                              };
                            }[];
                          };
                          blocked?: boolean;
                          preferedLanguage?: string;
                          /** @format date-time */
                          createdAt?: string;
                          /** @format date-time */
                          updatedAt?: string;
                          createdBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          updatedBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                        };
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              path?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  linkUrl: string;
  backgroundDimming?: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: BannerPromoListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface BannerPromoResponseDataObject {
  id?: number;
  attributes?: BannerPromo;
}

export interface BannerPromoResponse {
  data?: BannerPromoResponseDataObject;
  meta?: object;
}

export interface BannerSearchLocalizationRequest {
  /** @format date-time */
  date_start?: string;
  /** @format date-time */
  date_end?: string;
  title?: string;
  body?: any;
  /** @example "string or id" */
  media: number | string;
  linkUrl: string;
  label?: string;
  page: number;
  size?: "one" | "two" | "four";
  position?: number;
  blockId?: "mainPageSpecials" | "mainPage1" | "mainPage2" | "mainPage3" | "searchPage" | "hotelPage" | "landingPage";
  urlPattern?: string;
  locale: string;
}

export interface BannerSearchRequest {
  data: {
    /** @format date-time */
    date_start?: string;
    /** @format date-time */
    date_end?: string;
    title?: string;
    body?: any;
    /** @example "string or id" */
    media: number | string;
    linkUrl: string;
    label?: string;
    page: number;
    size?: "one" | "two" | "four";
    position?: number;
    blockId?: "mainPageSpecials" | "mainPage1" | "mainPage2" | "mainPage3" | "searchPage" | "hotelPage" | "landingPage";
    urlPattern?: string;
    locale?: string;
  };
}

export interface BannerSearchResponseDataObjectLocalized {
  id?: number;
  attributes?: BannerSearch;
}

export interface BannerSearchLocalizationResponse {
  data?: BannerSearchResponseDataObjectLocalized;
  meta?: object;
}

export interface BannerSearchListResponseDataItemLocalized {
  id?: number;
  attributes?: BannerSearch;
}

export interface BannerSearchLocalizationListResponse {
  data?: BannerSearchListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface BannerSearchListResponseDataItem {
  id?: number;
  attributes?: BannerSearch;
}

export interface BannerSearchListResponse {
  data?: BannerSearchListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface BannerSearch {
  /** @format date-time */
  date_start?: string;
  /** @format date-time */
  date_end?: string;
  title?: string;
  body?: any;
  media: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              pathId?: number;
              parent?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              children?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              files?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: {
                          firstname?: string;
                          lastname?: string;
                          username?: string;
                          /** @format email */
                          email?: string;
                          resetPasswordToken?: string;
                          registrationToken?: string;
                          isActive?: boolean;
                          roles?: {
                            data?: {
                              id?: number;
                              attributes?: {
                                name?: string;
                                code?: string;
                                description?: string;
                                users?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  }[];
                                };
                                permissions?: {
                                  data?: {
                                    id?: number;
                                    attributes?: {
                                      action?: string;
                                      actionParameters?: any;
                                      subject?: string;
                                      properties?: any;
                                      conditions?: any;
                                      role?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      /** @format date-time */
                                      createdAt?: string;
                                      /** @format date-time */
                                      updatedAt?: string;
                                      createdBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      updatedBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                    };
                                  }[];
                                };
                                /** @format date-time */
                                createdAt?: string;
                                /** @format date-time */
                                updatedAt?: string;
                                createdBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                                updatedBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                              };
                            }[];
                          };
                          blocked?: boolean;
                          preferedLanguage?: string;
                          /** @format date-time */
                          createdAt?: string;
                          /** @format date-time */
                          updatedAt?: string;
                          createdBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          updatedBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                        };
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              path?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  linkUrl: string;
  label?: string;
  page: number;
  size?: "one" | "two" | "four";
  position?: number;
  blockId?: "mainPageSpecials" | "mainPage1" | "mainPage2" | "mainPage3" | "searchPage" | "hotelPage" | "landingPage";
  urlPattern?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: BannerSearchListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface BannerSearchResponseDataObject {
  id?: number;
  attributes?: BannerSearch;
}

export interface BannerSearchResponse {
  data?: BannerSearchResponseDataObject;
  meta?: object;
}

export interface BookingOwnerDenyReasonLocalizationRequest {
  title?: string;
  entity_id?: number;
  locale: string;
}

export interface BookingOwnerDenyReasonRequest {
  data: {
    title?: string;
    entity_id?: number;
    locale?: string;
  };
}

export interface BookingOwnerDenyReasonResponseDataObjectLocalized {
  id?: number;
  attributes?: BookingOwnerDenyReason;
}

export interface BookingOwnerDenyReasonLocalizationResponse {
  data?: BookingOwnerDenyReasonResponseDataObjectLocalized;
  meta?: object;
}

export interface BookingOwnerDenyReasonListResponseDataItemLocalized {
  id?: number;
  attributes?: BookingOwnerDenyReason;
}

export interface BookingOwnerDenyReasonLocalizationListResponse {
  data?: BookingOwnerDenyReasonListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface BookingOwnerDenyReasonListResponseDataItem {
  id?: number;
  attributes?: BookingOwnerDenyReason;
}

export interface BookingOwnerDenyReasonListResponse {
  data?: BookingOwnerDenyReasonListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface BookingOwnerDenyReason {
  title?: string;
  entity_id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: {
        firstname?: string;
        lastname?: string;
        username?: string;
        /** @format email */
        email?: string;
        resetPasswordToken?: string;
        registrationToken?: string;
        isActive?: boolean;
        roles?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              code?: string;
              description?: string;
              users?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              permissions?: {
                data?: {
                  id?: number;
                  attributes?: {
                    action?: string;
                    actionParameters?: any;
                    subject?: string;
                    properties?: any;
                    conditions?: any;
                    role?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          }[];
        };
        blocked?: boolean;
        preferedLanguage?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: BookingOwnerDenyReasonListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface BookingOwnerDenyReasonResponseDataObject {
  id?: number;
  attributes?: BookingOwnerDenyReason;
}

export interface BookingOwnerDenyReasonResponse {
  data?: BookingOwnerDenyReasonResponseDataObject;
  meta?: object;
}

export interface CityLocalizationRequest {
  title?: string;
  entity_id?: number;
  show_on_search?: boolean;
  show_on_personal_cabinet?: boolean;
  order: number;
  locale: string;
}

export interface CityRequest {
  data: {
    title?: string;
    entity_id?: number;
    show_on_search?: boolean;
    show_on_personal_cabinet?: boolean;
    order: number;
    locale?: string;
  };
}

export interface CityResponseDataObjectLocalized {
  id?: number;
  attributes?: City;
}

export interface CityLocalizationResponse {
  data?: CityResponseDataObjectLocalized;
  meta?: object;
}

export interface CityListResponseDataItemLocalized {
  id?: number;
  attributes?: City;
}

export interface CityLocalizationListResponse {
  data?: CityListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface CityListResponseDataItem {
  id?: number;
  attributes?: City;
}

export interface CityListResponse {
  data?: CityListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface City {
  title?: string;
  entity_id?: number;
  show_on_search?: boolean;
  show_on_personal_cabinet?: boolean;
  order: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: {
        firstname?: string;
        lastname?: string;
        username?: string;
        /** @format email */
        email?: string;
        resetPasswordToken?: string;
        registrationToken?: string;
        isActive?: boolean;
        roles?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              code?: string;
              description?: string;
              users?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              permissions?: {
                data?: {
                  id?: number;
                  attributes?: {
                    action?: string;
                    actionParameters?: any;
                    subject?: string;
                    properties?: any;
                    conditions?: any;
                    role?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          }[];
        };
        blocked?: boolean;
        preferedLanguage?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: CityListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface CityResponseDataObject {
  id?: number;
  attributes?: City;
}

export interface CityResponse {
  data?: CityResponseDataObject;
  meta?: object;
}

export interface CityDistrictLocalizationRequest {
  title?: string;
  entity_id?: number;
  layout?: "default" | "landing";
  locale: string;
}

export interface CityDistrictRequest {
  data: {
    title?: string;
    entity_id?: number;
    layout?: "default" | "landing";
    locale?: string;
  };
}

export interface CityDistrictResponseDataObjectLocalized {
  id?: number;
  attributes?: CityDistrict;
}

export interface CityDistrictLocalizationResponse {
  data?: CityDistrictResponseDataObjectLocalized;
  meta?: object;
}

export interface CityDistrictListResponseDataItemLocalized {
  id?: number;
  attributes?: CityDistrict;
}

export interface CityDistrictLocalizationListResponse {
  data?: CityDistrictListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface CityDistrictListResponseDataItem {
  id?: number;
  attributes?: CityDistrict;
}

export interface CityDistrictListResponse {
  data?: CityDistrictListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface CityDistrict {
  title?: string;
  entity_id?: number;
  layout?: "default" | "landing";
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: {
        firstname?: string;
        lastname?: string;
        username?: string;
        /** @format email */
        email?: string;
        resetPasswordToken?: string;
        registrationToken?: string;
        isActive?: boolean;
        roles?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              code?: string;
              description?: string;
              users?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              permissions?: {
                data?: {
                  id?: number;
                  attributes?: {
                    action?: string;
                    actionParameters?: any;
                    subject?: string;
                    properties?: any;
                    conditions?: any;
                    role?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          }[];
        };
        blocked?: boolean;
        preferedLanguage?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: CityDistrictListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface CityDistrictResponseDataObject {
  id?: number;
  attributes?: CityDistrict;
}

export interface CityDistrictResponse {
  data?: CityDistrictResponseDataObject;
  meta?: object;
}

export interface CountryLocalizationRequest {
  title: string;
  entity_id?: number;
  locale: string;
}

export interface CountryRequest {
  data: {
    title: string;
    entity_id?: number;
    locale?: string;
  };
}

export interface CountryResponseDataObjectLocalized {
  id?: number;
  attributes?: Country;
}

export interface CountryLocalizationResponse {
  data?: CountryResponseDataObjectLocalized;
  meta?: object;
}

export interface CountryListResponseDataItemLocalized {
  id?: number;
  attributes?: Country;
}

export interface CountryLocalizationListResponse {
  data?: CountryListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface CountryListResponseDataItem {
  id?: number;
  attributes?: Country;
}

export interface CountryListResponse {
  data?: CountryListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface Country {
  title: string;
  entity_id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: {
        firstname?: string;
        lastname?: string;
        username?: string;
        /** @format email */
        email?: string;
        resetPasswordToken?: string;
        registrationToken?: string;
        isActive?: boolean;
        roles?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              code?: string;
              description?: string;
              users?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              permissions?: {
                data?: {
                  id?: number;
                  attributes?: {
                    action?: string;
                    actionParameters?: any;
                    subject?: string;
                    properties?: any;
                    conditions?: any;
                    role?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          }[];
        };
        blocked?: boolean;
        preferedLanguage?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: CountryListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface CountryResponseDataObject {
  id?: number;
  attributes?: Country;
}

export interface CountryResponse {
  data?: CountryResponseDataObject;
  meta?: object;
}

export interface HeaderBannerLocalizationRequest {
  use_dark_logo?: boolean;
  priority?: number;
  production?: boolean;
  /** @example "string or id" */
  image?: number | string;
  /** @example "string or id" */
  imageMobile?: number | string;
  backgroundColor?: string;
  title?: string;
  locale: string;
}

export interface HeaderBannerRequest {
  data: {
    use_dark_logo?: boolean;
    priority?: number;
    production?: boolean;
    /** @example "string or id" */
    image?: number | string;
    /** @example "string or id" */
    imageMobile?: number | string;
    backgroundColor?: string;
    title?: string;
    locale?: string;
  };
}

export interface HeaderBannerResponseDataObjectLocalized {
  id?: number;
  attributes?: HeaderBanner;
}

export interface HeaderBannerLocalizationResponse {
  data?: HeaderBannerResponseDataObjectLocalized;
  meta?: object;
}

export interface HeaderBannerListResponseDataItemLocalized {
  id?: number;
  attributes?: HeaderBanner;
}

export interface HeaderBannerLocalizationListResponse {
  data?: HeaderBannerListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HeaderBannerListResponseDataItem {
  id?: number;
  attributes?: HeaderBanner;
}

export interface HeaderBannerListResponse {
  data?: HeaderBannerListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HeaderBanner {
  use_dark_logo?: boolean;
  priority?: number;
  production?: boolean;
  image?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              pathId?: number;
              parent?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              children?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              files?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: {
                          firstname?: string;
                          lastname?: string;
                          username?: string;
                          /** @format email */
                          email?: string;
                          resetPasswordToken?: string;
                          registrationToken?: string;
                          isActive?: boolean;
                          roles?: {
                            data?: {
                              id?: number;
                              attributes?: {
                                name?: string;
                                code?: string;
                                description?: string;
                                users?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  }[];
                                };
                                permissions?: {
                                  data?: {
                                    id?: number;
                                    attributes?: {
                                      action?: string;
                                      actionParameters?: any;
                                      subject?: string;
                                      properties?: any;
                                      conditions?: any;
                                      role?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      /** @format date-time */
                                      createdAt?: string;
                                      /** @format date-time */
                                      updatedAt?: string;
                                      createdBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      updatedBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                    };
                                  }[];
                                };
                                /** @format date-time */
                                createdAt?: string;
                                /** @format date-time */
                                updatedAt?: string;
                                createdBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                                updatedBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                              };
                            }[];
                          };
                          blocked?: boolean;
                          preferedLanguage?: string;
                          /** @format date-time */
                          createdAt?: string;
                          /** @format date-time */
                          updatedAt?: string;
                          createdBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          updatedBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                        };
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              path?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  imageMobile?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  backgroundColor?: string;
  title?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: HeaderBannerListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface HeaderBannerResponseDataObject {
  id?: number;
  attributes?: HeaderBanner;
}

export interface HeaderBannerResponse {
  data?: HeaderBannerResponseDataObject;
  meta?: object;
}

export interface HotelLocalizationRequest {
  slug?: string;
  title?: string;
  short_description?: string;
  description?: string;
  entity_id?: string;
  /** @example "string or id" */
  icon?: number | string;
  contact_number?: string;
  media?: CommonMediaWrapperComponent[];
  documents?: CommonDocumentWrapperComponent[];
  media2?: (number | string)[];
  documents2?: (number | string)[];
  locale: string;
}

export interface HotelRequest {
  data: {
    slug?: string;
    title?: string;
    short_description?: string;
    description?: string;
    entity_id?: string;
    /** @example "string or id" */
    icon?: number | string;
    contact_number?: string;
    media?: CommonMediaWrapperComponent[];
    documents?: CommonDocumentWrapperComponent[];
    media2?: (number | string)[];
    documents2?: (number | string)[];
    locale?: string;
  };
}

export interface HotelResponseDataObjectLocalized {
  id?: number;
  attributes?: Hotel;
}

export interface HotelLocalizationResponse {
  data?: HotelResponseDataObjectLocalized;
  meta?: object;
}

export interface HotelListResponseDataItemLocalized {
  id?: number;
  attributes?: Hotel;
}

export interface HotelLocalizationListResponse {
  data?: HotelListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelListResponseDataItem {
  id?: number;
  attributes?: Hotel;
}

export interface HotelListResponse {
  data?: HotelListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface Hotel {
  slug?: string;
  title?: string;
  short_description?: string;
  description?: string;
  entity_id?: string;
  icon?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              pathId?: number;
              parent?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              children?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              files?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: {
                          firstname?: string;
                          lastname?: string;
                          username?: string;
                          /** @format email */
                          email?: string;
                          resetPasswordToken?: string;
                          registrationToken?: string;
                          isActive?: boolean;
                          roles?: {
                            data?: {
                              id?: number;
                              attributes?: {
                                name?: string;
                                code?: string;
                                description?: string;
                                users?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  }[];
                                };
                                permissions?: {
                                  data?: {
                                    id?: number;
                                    attributes?: {
                                      action?: string;
                                      actionParameters?: any;
                                      subject?: string;
                                      properties?: any;
                                      conditions?: any;
                                      role?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      /** @format date-time */
                                      createdAt?: string;
                                      /** @format date-time */
                                      updatedAt?: string;
                                      createdBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      updatedBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                    };
                                  }[];
                                };
                                /** @format date-time */
                                createdAt?: string;
                                /** @format date-time */
                                updatedAt?: string;
                                createdBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                                updatedBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                              };
                            }[];
                          };
                          blocked?: boolean;
                          preferedLanguage?: string;
                          /** @format date-time */
                          createdAt?: string;
                          /** @format date-time */
                          updatedAt?: string;
                          createdBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          updatedBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                        };
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              path?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  contact_number?: string;
  media?: CommonMediaWrapperComponent[];
  documents?: CommonDocumentWrapperComponent[];
  media2?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    }[];
  };
  documents2?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    }[];
  };
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: HotelListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface HotelResponseDataObject {
  id?: number;
  attributes?: Hotel;
}

export interface HotelResponse {
  data?: HotelResponseDataObject;
  meta?: object;
}

export interface CommonMediaWrapperComponent {
  id?: number;
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  order?: number;
}

export interface CommonDocumentWrapperComponent {
  id?: number;
  document?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  order?: number;
}

export interface HotelAdditionalServiceLocalizationRequest {
  title?: string;
  description?: string;
  entity_id?: string;
  locale: string;
}

export interface HotelAdditionalServiceRequest {
  data: {
    title?: string;
    description?: string;
    entity_id?: string;
    locale?: string;
  };
}

export interface HotelAdditionalServiceResponseDataObjectLocalized {
  id?: number;
  attributes?: HotelAdditionalService;
}

export interface HotelAdditionalServiceLocalizationResponse {
  data?: HotelAdditionalServiceResponseDataObjectLocalized;
  meta?: object;
}

export interface HotelAdditionalServiceListResponseDataItemLocalized {
  id?: number;
  attributes?: HotelAdditionalService;
}

export interface HotelAdditionalServiceLocalizationListResponse {
  data?: HotelAdditionalServiceListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelAdditionalServiceListResponseDataItem {
  id?: number;
  attributes?: HotelAdditionalService;
}

export interface HotelAdditionalServiceListResponse {
  data?: HotelAdditionalServiceListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelAdditionalService {
  title?: string;
  description?: string;
  entity_id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: {
        firstname?: string;
        lastname?: string;
        username?: string;
        /** @format email */
        email?: string;
        resetPasswordToken?: string;
        registrationToken?: string;
        isActive?: boolean;
        roles?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              code?: string;
              description?: string;
              users?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              permissions?: {
                data?: {
                  id?: number;
                  attributes?: {
                    action?: string;
                    actionParameters?: any;
                    subject?: string;
                    properties?: any;
                    conditions?: any;
                    role?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          }[];
        };
        blocked?: boolean;
        preferedLanguage?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: HotelAdditionalServiceListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface HotelAdditionalServiceResponseDataObject {
  id?: number;
  attributes?: HotelAdditionalService;
}

export interface HotelAdditionalServiceResponse {
  data?: HotelAdditionalServiceResponseDataObject;
  meta?: object;
}

export interface HotelAttributeLocalizationRequest {
  code?: string;
  priority?: number;
  show_on_main_page?: boolean;
  title?: string;
  description?: string;
  entity_id?: number;
  /** @example "string or id" */
  icon?: number | string;
  show_in_attributes_on_mini_cards?: boolean;
  locale: string;
}

export interface HotelAttributeRequest {
  data: {
    code?: string;
    priority?: number;
    show_on_main_page?: boolean;
    title?: string;
    description?: string;
    entity_id?: number;
    /** @example "string or id" */
    icon?: number | string;
    show_in_attributes_on_mini_cards?: boolean;
    locale?: string;
  };
}

export interface HotelAttributeResponseDataObjectLocalized {
  id?: number;
  attributes?: HotelAttribute;
}

export interface HotelAttributeLocalizationResponse {
  data?: HotelAttributeResponseDataObjectLocalized;
  meta?: object;
}

export interface HotelAttributeListResponseDataItemLocalized {
  id?: number;
  attributes?: HotelAttribute;
}

export interface HotelAttributeLocalizationListResponse {
  data?: HotelAttributeListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelAttributeListResponseDataItem {
  id?: number;
  attributes?: HotelAttribute;
}

export interface HotelAttributeListResponse {
  data?: HotelAttributeListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelAttribute {
  code?: string;
  priority?: number;
  show_on_main_page?: boolean;
  title?: string;
  description?: string;
  entity_id?: number;
  icon?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              pathId?: number;
              parent?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              children?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              files?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: {
                          firstname?: string;
                          lastname?: string;
                          username?: string;
                          /** @format email */
                          email?: string;
                          resetPasswordToken?: string;
                          registrationToken?: string;
                          isActive?: boolean;
                          roles?: {
                            data?: {
                              id?: number;
                              attributes?: {
                                name?: string;
                                code?: string;
                                description?: string;
                                users?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  }[];
                                };
                                permissions?: {
                                  data?: {
                                    id?: number;
                                    attributes?: {
                                      action?: string;
                                      actionParameters?: any;
                                      subject?: string;
                                      properties?: any;
                                      conditions?: any;
                                      role?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      /** @format date-time */
                                      createdAt?: string;
                                      /** @format date-time */
                                      updatedAt?: string;
                                      createdBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      updatedBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                    };
                                  }[];
                                };
                                /** @format date-time */
                                createdAt?: string;
                                /** @format date-time */
                                updatedAt?: string;
                                createdBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                                updatedBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                              };
                            }[];
                          };
                          blocked?: boolean;
                          preferedLanguage?: string;
                          /** @format date-time */
                          createdAt?: string;
                          /** @format date-time */
                          updatedAt?: string;
                          createdBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          updatedBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                        };
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              path?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  show_in_attributes_on_mini_cards?: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: HotelAttributeListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface HotelAttributeResponseDataObject {
  id?: number;
  attributes?: HotelAttribute;
}

export interface HotelAttributeResponse {
  data?: HotelAttributeResponseDataObject;
  meta?: object;
}

export interface HotelAttributeGroupLocalizationRequest {
  entity_id?: number;
  title?: string;
  priority?: number;
  show_on_main_page?: boolean;
  code?: string;
  maxItemsPerRow?: "one" | "two" | "three" | "four";
  locale: string;
}

export interface HotelAttributeGroupRequest {
  data: {
    entity_id?: number;
    title?: string;
    priority?: number;
    show_on_main_page?: boolean;
    code?: string;
    maxItemsPerRow?: "one" | "two" | "three" | "four";
    locale?: string;
  };
}

export interface HotelAttributeGroupResponseDataObjectLocalized {
  id?: number;
  attributes?: HotelAttributeGroup;
}

export interface HotelAttributeGroupLocalizationResponse {
  data?: HotelAttributeGroupResponseDataObjectLocalized;
  meta?: object;
}

export interface HotelAttributeGroupListResponseDataItemLocalized {
  id?: number;
  attributes?: HotelAttributeGroup;
}

export interface HotelAttributeGroupLocalizationListResponse {
  data?: HotelAttributeGroupListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelAttributeGroupListResponseDataItem {
  id?: number;
  attributes?: HotelAttributeGroup;
}

export interface HotelAttributeGroupListResponse {
  data?: HotelAttributeGroupListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelAttributeGroup {
  entity_id?: number;
  title?: string;
  priority?: number;
  show_on_main_page?: boolean;
  code?: string;
  maxItemsPerRow?: "one" | "two" | "three" | "four";
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: {
        firstname?: string;
        lastname?: string;
        username?: string;
        /** @format email */
        email?: string;
        resetPasswordToken?: string;
        registrationToken?: string;
        isActive?: boolean;
        roles?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              code?: string;
              description?: string;
              users?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              permissions?: {
                data?: {
                  id?: number;
                  attributes?: {
                    action?: string;
                    actionParameters?: any;
                    subject?: string;
                    properties?: any;
                    conditions?: any;
                    role?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          }[];
        };
        blocked?: boolean;
        preferedLanguage?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: HotelAttributeGroupListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface HotelAttributeGroupResponseDataObject {
  id?: number;
  attributes?: HotelAttributeGroup;
}

export interface HotelAttributeGroupResponse {
  data?: HotelAttributeGroupResponseDataObject;
  meta?: object;
}

export interface HotelUnitLocalizationRequest {
  media?: (number | string)[];
  entity_id?: string;
  locale: string;
}

export interface HotelUnitRequest {
  data: {
    media?: (number | string)[];
    entity_id?: string;
    locale?: string;
  };
}

export interface HotelUnitResponseDataObjectLocalized {
  id?: number;
  attributes?: HotelUnit;
}

export interface HotelUnitLocalizationResponse {
  data?: HotelUnitResponseDataObjectLocalized;
  meta?: object;
}

export interface HotelUnitListResponseDataItemLocalized {
  id?: number;
  attributes?: HotelUnit;
}

export interface HotelUnitLocalizationListResponse {
  data?: HotelUnitListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelUnitListResponseDataItem {
  id?: number;
  attributes?: HotelUnit;
}

export interface HotelUnitListResponse {
  data?: HotelUnitListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelUnit {
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              pathId?: number;
              parent?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              children?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              files?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: {
                          firstname?: string;
                          lastname?: string;
                          username?: string;
                          /** @format email */
                          email?: string;
                          resetPasswordToken?: string;
                          registrationToken?: string;
                          isActive?: boolean;
                          roles?: {
                            data?: {
                              id?: number;
                              attributes?: {
                                name?: string;
                                code?: string;
                                description?: string;
                                users?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  }[];
                                };
                                permissions?: {
                                  data?: {
                                    id?: number;
                                    attributes?: {
                                      action?: string;
                                      actionParameters?: any;
                                      subject?: string;
                                      properties?: any;
                                      conditions?: any;
                                      role?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      /** @format date-time */
                                      createdAt?: string;
                                      /** @format date-time */
                                      updatedAt?: string;
                                      createdBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      updatedBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                    };
                                  }[];
                                };
                                /** @format date-time */
                                createdAt?: string;
                                /** @format date-time */
                                updatedAt?: string;
                                createdBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                                updatedBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                              };
                            }[];
                          };
                          blocked?: boolean;
                          preferedLanguage?: string;
                          /** @format date-time */
                          createdAt?: string;
                          /** @format date-time */
                          updatedAt?: string;
                          createdBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          updatedBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                        };
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              path?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    }[];
  };
  entity_id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: HotelUnitListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface HotelUnitResponseDataObject {
  id?: number;
  attributes?: HotelUnit;
}

export interface HotelUnitResponse {
  data?: HotelUnitResponseDataObject;
  meta?: object;
}

export interface HotelUnitGroupLocalizationRequest {
  title?: string;
  short_description?: string;
  description?: string;
  media?: (number | string)[];
  entity_id?: string;
  locale: string;
}

export interface HotelUnitGroupRequest {
  data: {
    title?: string;
    short_description?: string;
    description?: string;
    media?: (number | string)[];
    entity_id?: string;
    locale?: string;
  };
}

export interface HotelUnitGroupResponseDataObjectLocalized {
  id?: number;
  attributes?: HotelUnitGroup;
}

export interface HotelUnitGroupLocalizationResponse {
  data?: HotelUnitGroupResponseDataObjectLocalized;
  meta?: object;
}

export interface HotelUnitGroupListResponseDataItemLocalized {
  id?: number;
  attributes?: HotelUnitGroup;
}

export interface HotelUnitGroupLocalizationListResponse {
  data?: HotelUnitGroupListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelUnitGroupListResponseDataItem {
  id?: number;
  attributes?: HotelUnitGroup;
}

export interface HotelUnitGroupListResponse {
  data?: HotelUnitGroupListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelUnitGroup {
  title?: string;
  short_description?: string;
  description?: string;
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              pathId?: number;
              parent?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              children?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              files?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: {
                          firstname?: string;
                          lastname?: string;
                          username?: string;
                          /** @format email */
                          email?: string;
                          resetPasswordToken?: string;
                          registrationToken?: string;
                          isActive?: boolean;
                          roles?: {
                            data?: {
                              id?: number;
                              attributes?: {
                                name?: string;
                                code?: string;
                                description?: string;
                                users?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  }[];
                                };
                                permissions?: {
                                  data?: {
                                    id?: number;
                                    attributes?: {
                                      action?: string;
                                      actionParameters?: any;
                                      subject?: string;
                                      properties?: any;
                                      conditions?: any;
                                      role?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      /** @format date-time */
                                      createdAt?: string;
                                      /** @format date-time */
                                      updatedAt?: string;
                                      createdBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      updatedBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                    };
                                  }[];
                                };
                                /** @format date-time */
                                createdAt?: string;
                                /** @format date-time */
                                updatedAt?: string;
                                createdBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                                updatedBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                              };
                            }[];
                          };
                          blocked?: boolean;
                          preferedLanguage?: string;
                          /** @format date-time */
                          createdAt?: string;
                          /** @format date-time */
                          updatedAt?: string;
                          createdBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          updatedBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                        };
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              path?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    }[];
  };
  entity_id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: HotelUnitGroupListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface HotelUnitGroupResponseDataObject {
  id?: number;
  attributes?: HotelUnitGroup;
}

export interface HotelUnitGroupResponse {
  data?: HotelUnitGroupResponseDataObject;
  meta?: object;
}

export interface HotelUnitGroupAttributeLocalizationRequest {
  priority?: number;
  description?: string;
  title?: string;
  code?: string;
  entity_id?: number;
  /** @example "string or id" */
  icon?: number | string;
  full_title?: string;
  show_in_main_slider?: boolean;
  show_in_sidebar_filters?: boolean;
  show_in_attributes_on_mini_cards?: boolean;
  hide_on_card?: boolean;
  /** @example "string or id" */
  photo?: number | string;
  show_in_personal_cabinet?: boolean;
  locale: string;
}

export interface HotelUnitGroupAttributeRequest {
  data: {
    priority?: number;
    description?: string;
    title?: string;
    code?: string;
    entity_id?: number;
    /** @example "string or id" */
    icon?: number | string;
    full_title?: string;
    show_in_main_slider?: boolean;
    show_in_sidebar_filters?: boolean;
    show_in_attributes_on_mini_cards?: boolean;
    hide_on_card?: boolean;
    /** @example "string or id" */
    photo?: number | string;
    show_in_personal_cabinet?: boolean;
    locale?: string;
  };
}

export interface HotelUnitGroupAttributeResponseDataObjectLocalized {
  id?: number;
  attributes?: HotelUnitGroupAttribute;
}

export interface HotelUnitGroupAttributeLocalizationResponse {
  data?: HotelUnitGroupAttributeResponseDataObjectLocalized;
  meta?: object;
}

export interface HotelUnitGroupAttributeListResponseDataItemLocalized {
  id?: number;
  attributes?: HotelUnitGroupAttribute;
}

export interface HotelUnitGroupAttributeLocalizationListResponse {
  data?: HotelUnitGroupAttributeListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelUnitGroupAttributeListResponseDataItem {
  id?: number;
  attributes?: HotelUnitGroupAttribute;
}

export interface HotelUnitGroupAttributeListResponse {
  data?: HotelUnitGroupAttributeListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelUnitGroupAttribute {
  priority?: number;
  description?: string;
  title?: string;
  code?: string;
  entity_id?: number;
  icon?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              pathId?: number;
              parent?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              children?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              files?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: {
                          firstname?: string;
                          lastname?: string;
                          username?: string;
                          /** @format email */
                          email?: string;
                          resetPasswordToken?: string;
                          registrationToken?: string;
                          isActive?: boolean;
                          roles?: {
                            data?: {
                              id?: number;
                              attributes?: {
                                name?: string;
                                code?: string;
                                description?: string;
                                users?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  }[];
                                };
                                permissions?: {
                                  data?: {
                                    id?: number;
                                    attributes?: {
                                      action?: string;
                                      actionParameters?: any;
                                      subject?: string;
                                      properties?: any;
                                      conditions?: any;
                                      role?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      /** @format date-time */
                                      createdAt?: string;
                                      /** @format date-time */
                                      updatedAt?: string;
                                      createdBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      updatedBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                    };
                                  }[];
                                };
                                /** @format date-time */
                                createdAt?: string;
                                /** @format date-time */
                                updatedAt?: string;
                                createdBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                                updatedBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                              };
                            }[];
                          };
                          blocked?: boolean;
                          preferedLanguage?: string;
                          /** @format date-time */
                          createdAt?: string;
                          /** @format date-time */
                          updatedAt?: string;
                          createdBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          updatedBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                        };
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              path?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  full_title?: string;
  show_in_main_slider?: boolean;
  show_in_sidebar_filters?: boolean;
  show_in_attributes_on_mini_cards?: boolean;
  hide_on_card?: boolean;
  photo?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  show_in_personal_cabinet?: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: HotelUnitGroupAttributeListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface HotelUnitGroupAttributeResponseDataObject {
  id?: number;
  attributes?: HotelUnitGroupAttribute;
}

export interface HotelUnitGroupAttributeResponse {
  data?: HotelUnitGroupAttributeResponseDataObject;
  meta?: object;
}

export interface HotelUnitGroupAttributeGroupLocalizationRequest {
  title?: string;
  priority?: number;
  code?: string;
  entity_id?: number;
  render_type: "Checkbox" | "Radio";
  full_title?: string;
  show_in_sidebar_filters?: boolean;
  title_sidebar?: string;
  title_single_page?: string;
  maxItemsPerRow?: "one" | "two" | "three" | "four";
  sidebar_filter_render_type?: "radio_or_checkbox" | "chip" | "select";
  sidebar_filter_allow_multi_selection?: boolean;
  sidebar_filter_max_initial_options?: number;
  sidebar_filter_show_options_inline?: boolean;
  locale: string;
}

export interface HotelUnitGroupAttributeGroupRequest {
  data: {
    title?: string;
    priority?: number;
    code?: string;
    entity_id?: number;
    render_type: "Checkbox" | "Radio";
    full_title?: string;
    show_in_sidebar_filters?: boolean;
    title_sidebar?: string;
    title_single_page?: string;
    maxItemsPerRow?: "one" | "two" | "three" | "four";
    sidebar_filter_render_type?: "radio_or_checkbox" | "chip" | "select";
    sidebar_filter_allow_multi_selection?: boolean;
    sidebar_filter_max_initial_options?: number;
    sidebar_filter_show_options_inline?: boolean;
    locale?: string;
  };
}

export interface HotelUnitGroupAttributeGroupResponseDataObjectLocalized {
  id?: number;
  attributes?: HotelUnitGroupAttributeGroup;
}

export interface HotelUnitGroupAttributeGroupLocalizationResponse {
  data?: HotelUnitGroupAttributeGroupResponseDataObjectLocalized;
  meta?: object;
}

export interface HotelUnitGroupAttributeGroupListResponseDataItemLocalized {
  id?: number;
  attributes?: HotelUnitGroupAttributeGroup;
}

export interface HotelUnitGroupAttributeGroupLocalizationListResponse {
  data?: HotelUnitGroupAttributeGroupListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelUnitGroupAttributeGroupListResponseDataItem {
  id?: number;
  attributes?: HotelUnitGroupAttributeGroup;
}

export interface HotelUnitGroupAttributeGroupListResponse {
  data?: HotelUnitGroupAttributeGroupListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelUnitGroupAttributeGroup {
  title?: string;
  priority?: number;
  code?: string;
  entity_id?: number;
  render_type: "Checkbox" | "Radio";
  full_title?: string;
  show_in_sidebar_filters?: boolean;
  title_sidebar?: string;
  title_single_page?: string;
  maxItemsPerRow?: "one" | "two" | "three" | "four";
  sidebar_filter_render_type?: "radio_or_checkbox" | "chip" | "select";
  sidebar_filter_allow_multi_selection?: boolean;
  sidebar_filter_max_initial_options?: number;
  sidebar_filter_show_options_inline?: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: {
        firstname?: string;
        lastname?: string;
        username?: string;
        /** @format email */
        email?: string;
        resetPasswordToken?: string;
        registrationToken?: string;
        isActive?: boolean;
        roles?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              code?: string;
              description?: string;
              users?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              permissions?: {
                data?: {
                  id?: number;
                  attributes?: {
                    action?: string;
                    actionParameters?: any;
                    subject?: string;
                    properties?: any;
                    conditions?: any;
                    role?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          }[];
        };
        blocked?: boolean;
        preferedLanguage?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: HotelUnitGroupAttributeGroupListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface HotelUnitGroupAttributeGroupResponseDataObject {
  id?: number;
  attributes?: HotelUnitGroupAttributeGroup;
}

export interface HotelUnitGroupAttributeGroupResponse {
  data?: HotelUnitGroupAttributeGroupResponseDataObject;
  meta?: object;
}

export interface HotelUnitGroupPromotionLabelLocalizationRequest {
  title?: string;
  backgroundColor?: "orange" | "purple" | "green";
  entity_id?: string;
  locale: string;
}

export interface HotelUnitGroupPromotionLabelRequest {
  data: {
    title?: string;
    backgroundColor?: "orange" | "purple" | "green";
    entity_id?: string;
    locale?: string;
  };
}

export interface HotelUnitGroupPromotionLabelResponseDataObjectLocalized {
  id?: number;
  attributes?: HotelUnitGroupPromotionLabel;
}

export interface HotelUnitGroupPromotionLabelLocalizationResponse {
  data?: HotelUnitGroupPromotionLabelResponseDataObjectLocalized;
  meta?: object;
}

export interface HotelUnitGroupPromotionLabelListResponseDataItemLocalized {
  id?: number;
  attributes?: HotelUnitGroupPromotionLabel;
}

export interface HotelUnitGroupPromotionLabelLocalizationListResponse {
  data?: HotelUnitGroupPromotionLabelListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelUnitGroupPromotionLabelListResponseDataItem {
  id?: number;
  attributes?: HotelUnitGroupPromotionLabel;
}

export interface HotelUnitGroupPromotionLabelListResponse {
  data?: HotelUnitGroupPromotionLabelListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelUnitGroupPromotionLabel {
  title?: string;
  backgroundColor?: "orange" | "purple" | "green";
  entity_id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: {
        firstname?: string;
        lastname?: string;
        username?: string;
        /** @format email */
        email?: string;
        resetPasswordToken?: string;
        registrationToken?: string;
        isActive?: boolean;
        roles?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              code?: string;
              description?: string;
              users?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              permissions?: {
                data?: {
                  id?: number;
                  attributes?: {
                    action?: string;
                    actionParameters?: any;
                    subject?: string;
                    properties?: any;
                    conditions?: any;
                    role?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          }[];
        };
        blocked?: boolean;
        preferedLanguage?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: HotelUnitGroupPromotionLabelListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface HotelUnitGroupPromotionLabelResponseDataObject {
  id?: number;
  attributes?: HotelUnitGroupPromotionLabel;
}

export interface HotelUnitGroupPromotionLabelResponse {
  data?: HotelUnitGroupPromotionLabelResponseDataObject;
  meta?: object;
}

export interface HotelUnitGroupViewTypeLocalizationRequest {
  title: string;
  entity_id?: string;
  locale: string;
}

export interface HotelUnitGroupViewTypeRequest {
  data: {
    title: string;
    entity_id?: string;
    locale?: string;
  };
}

export interface HotelUnitGroupViewTypeResponseDataObjectLocalized {
  id?: number;
  attributes?: HotelUnitGroupViewType;
}

export interface HotelUnitGroupViewTypeLocalizationResponse {
  data?: HotelUnitGroupViewTypeResponseDataObjectLocalized;
  meta?: object;
}

export interface HotelUnitGroupViewTypeListResponseDataItemLocalized {
  id?: number;
  attributes?: HotelUnitGroupViewType;
}

export interface HotelUnitGroupViewTypeLocalizationListResponse {
  data?: HotelUnitGroupViewTypeListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelUnitGroupViewTypeListResponseDataItem {
  id?: number;
  attributes?: HotelUnitGroupViewType;
}

export interface HotelUnitGroupViewTypeListResponse {
  data?: HotelUnitGroupViewTypeListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface HotelUnitGroupViewType {
  title: string;
  entity_id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: {
        firstname?: string;
        lastname?: string;
        username?: string;
        /** @format email */
        email?: string;
        resetPasswordToken?: string;
        registrationToken?: string;
        isActive?: boolean;
        roles?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              code?: string;
              description?: string;
              users?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              permissions?: {
                data?: {
                  id?: number;
                  attributes?: {
                    action?: string;
                    actionParameters?: any;
                    subject?: string;
                    properties?: any;
                    conditions?: any;
                    role?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          }[];
        };
        blocked?: boolean;
        preferedLanguage?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: HotelUnitGroupViewTypeListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface HotelUnitGroupViewTypeResponseDataObject {
  id?: number;
  attributes?: HotelUnitGroupViewType;
}

export interface HotelUnitGroupViewTypeResponse {
  data?: HotelUnitGroupViewTypeResponseDataObject;
  meta?: object;
}

export interface IncomingRequestRequest {
  data: {
    name: string;
    /** @format email */
    email: string;
    phone?: string;
    comment?: string;
    status: "new" | "seen";
    form_id?: string;
    path_name?: string;
  };
}

export interface IncomingRequestListResponseDataItem {
  id?: number;
  attributes?: IncomingRequest;
}

export interface IncomingRequestListResponse {
  data?: IncomingRequestListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface IncomingRequest {
  name: string;
  /** @format email */
  email: string;
  phone?: string;
  comment?: string;
  status: "new" | "seen";
  form_id?: string;
  path_name?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: {
        firstname?: string;
        lastname?: string;
        username?: string;
        /** @format email */
        email?: string;
        resetPasswordToken?: string;
        registrationToken?: string;
        isActive?: boolean;
        roles?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              code?: string;
              description?: string;
              users?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              permissions?: {
                data?: {
                  id?: number;
                  attributes?: {
                    action?: string;
                    actionParameters?: any;
                    subject?: string;
                    properties?: any;
                    conditions?: any;
                    role?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          }[];
        };
        blocked?: boolean;
        preferedLanguage?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
}

export interface IncomingRequestResponseDataObject {
  id?: number;
  attributes?: IncomingRequest;
}

export interface IncomingRequestResponse {
  data?: IncomingRequestResponseDataObject;
  meta?: object;
}

export interface LandingPageLocalizationRequest {
  title?: string;
  slug?: string;
  content?: (
    | StaticPagesTitleComponent
    | StaticPagesFactoidsListComponent
    | StaticPagesZigZagListComponent
    | StaticPagesOffersComponent
    | StaticPagesParagpraphComponent
    | StaticPagesBannerCarouselComponent
    | StaticPagesTextBlockComponent
    | StaticPagesQuoteComponent
    | StaticPagesGridItemsComponent
    | StaticPagesGridCardComponent
    | StaticPagesHeroComponent
    | StaticPagesZigZagBlockComponent
    | StaticPagesImageComponent
    | StaticPagesFaqComponent
    | StaticPagesButtonBlockComponent
    | StaticPagesImageGalleryComponent
    | StaticPagesFeatureListComponent
  )[];
  layout?: "default" | "landing";
  seo: CommonSeoComponent;
  locale: string;
}

export interface LandingPageRequest {
  data: {
    title?: string;
    slug?: string;
    content?: (
      | StaticPagesTitleComponent
      | StaticPagesFactoidsListComponent
      | StaticPagesZigZagListComponent
      | StaticPagesOffersComponent
      | StaticPagesParagpraphComponent
      | StaticPagesBannerCarouselComponent
      | StaticPagesTextBlockComponent
      | StaticPagesQuoteComponent
      | StaticPagesGridItemsComponent
      | StaticPagesGridCardComponent
      | StaticPagesHeroComponent
      | StaticPagesZigZagBlockComponent
      | StaticPagesImageComponent
      | StaticPagesFaqComponent
      | StaticPagesButtonBlockComponent
      | StaticPagesImageGalleryComponent
      | StaticPagesFeatureListComponent
    )[];
    layout?: "default" | "landing";
    seo: CommonSeoComponent;
    locale?: string;
  };
}

export interface LandingPageResponseDataObjectLocalized {
  id?: number;
  attributes?: LandingPage;
}

export interface LandingPageLocalizationResponse {
  data?: LandingPageResponseDataObjectLocalized;
  meta?: object;
}

export interface LandingPageListResponseDataItemLocalized {
  id?: number;
  attributes?: LandingPage;
}

export interface LandingPageLocalizationListResponse {
  data?: LandingPageListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface LandingPageListResponseDataItem {
  id?: number;
  attributes?: LandingPage;
}

export interface LandingPageListResponse {
  data?: LandingPageListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface LandingPage {
  title?: string;
  slug?: string;
  content?: (
    | StaticPagesTitleComponent
    | StaticPagesFactoidsListComponent
    | StaticPagesZigZagListComponent
    | StaticPagesOffersComponent
    | StaticPagesParagpraphComponent
    | StaticPagesBannerCarouselComponent
    | StaticPagesTextBlockComponent
    | StaticPagesQuoteComponent
    | StaticPagesGridItemsComponent
    | StaticPagesGridCardComponent
    | StaticPagesHeroComponent
    | StaticPagesZigZagBlockComponent
    | StaticPagesImageComponent
    | StaticPagesFaqComponent
    | StaticPagesButtonBlockComponent
    | StaticPagesImageGalleryComponent
    | StaticPagesFeatureListComponent
  )[];
  layout?: "default" | "landing";
  seo: CommonSeoComponent;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: LandingPageListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface LandingPageResponseDataObject {
  id?: number;
  attributes?: LandingPage;
}

export interface LandingPageResponse {
  data?: LandingPageResponseDataObject;
  meta?: object;
}

export interface StaticPagesTitleComponent {
  id?: number;
  __component?: string;
  text?: string;
  align?: "center" | "left" | "right";
  variant?: "h1" | "h2" | "h3";
}

export interface StaticPagesFactoidComponent {
  id?: number;
  text?: string;
  helpText?: string;
  value?: string;
  valueVariant?: "h3" | "h5";
}

export interface StaticPagesFactoidsListComponent {
  id?: number;
  __component?: string;
  items?: StaticPagesFactoidComponent[];
}

export interface StaticPagesZigZagComponent {
  id?: number;
  title?: string;
  text?: any;
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              pathId?: number;
              parent?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              children?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              files?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: {
                          firstname?: string;
                          lastname?: string;
                          username?: string;
                          /** @format email */
                          email?: string;
                          resetPasswordToken?: string;
                          registrationToken?: string;
                          isActive?: boolean;
                          roles?: {
                            data?: {
                              id?: number;
                              attributes?: {
                                name?: string;
                                code?: string;
                                description?: string;
                                users?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  }[];
                                };
                                permissions?: {
                                  data?: {
                                    id?: number;
                                    attributes?: {
                                      action?: string;
                                      actionParameters?: any;
                                      subject?: string;
                                      properties?: any;
                                      conditions?: any;
                                      role?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      /** @format date-time */
                                      createdAt?: string;
                                      /** @format date-time */
                                      updatedAt?: string;
                                      createdBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      updatedBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                    };
                                  }[];
                                };
                                /** @format date-time */
                                createdAt?: string;
                                /** @format date-time */
                                updatedAt?: string;
                                createdBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                                updatedBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                              };
                            }[];
                          };
                          blocked?: boolean;
                          preferedLanguage?: string;
                          /** @format date-time */
                          createdAt?: string;
                          /** @format date-time */
                          updatedAt?: string;
                          createdBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          updatedBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                        };
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              path?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  media2?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  variant?: "left" | "right";
  isCentered?: boolean;
}

export interface StaticPagesZigZagListComponent {
  id?: number;
  __component?: string;
  items?: StaticPagesZigZagComponent[];
}

export interface StaticPagesOffersComponent {
  id?: number;
  __component?: string;
  filterLink?: string;
}

export interface CommonContainerPropsComponent {
  id?: number;
  maxWidth?: "md" | "lg" | "xl" | "full";
  backgroundColor?:
    | "primary.main"
    | "primary.dark"
    | "primary.darker"
    | "secondary.main"
    | "secondary.dark"
    | "secondary.darker";
  /** @format float */
  marginTop?: number;
  /** @format float */
  marginBottom?: number;
  /** @format float */
  paddingTop?: number;
  /** @format float */
  paddingBottom?: number;
}

export interface StaticPagesParagpraphComponent {
  id?: number;
  __component?: string;
  content?: any;
  textAlign?: "center" | "left" | "right";
  containerProps?: CommonContainerPropsComponent;
}

export interface StaticPagesBannerComponent {
  id?: number;
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  title?: string;
  subtitle?: string;
  text?: any;
  withLogo?: boolean;
  textAlign?: "center" | "left" | "right";
  ctaTitle?: string;
  ctaLink?: string;
  textDark?: boolean;
  ctaColor?: "primary" | "secondary" | "error" | "success";
}

export interface StaticPagesBannerCarouselComponent {
  id?: number;
  __component?: string;
  items?: StaticPagesBannerComponent[];
}

export interface StaticPagesTextBlockComponent {
  id?: number;
  __component?: string;
  title?: string;
  body?: any;
  variant?: "h1" | "h2" | "h3";
  isCentered?: boolean;
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  containerProps?: CommonContainerPropsComponent;
}

export interface StaticPagesQuoteComponent {
  id?: number;
  __component?: string;
  title?: string;
  name?: string;
  jobTitle?: string;
  variant?: "left" | "right" | "withBorder";
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  containerProps?: CommonContainerPropsComponent;
  body?: any;
  isCentered?: boolean;
  bgStyle?: "primary" | "secondary";
}

export interface StaticPagesGridCardComponent {
  id?: number;
  __component?: string;
  title?: string;
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  body?: any;
  icon?: string;
  isCentered?: boolean;
  variant?: "h3" | "h5";
  backgroundColor?: string;
  linkText?: string;
  linkUrl?: string;
}

export interface StaticPagesGridItemsComponent {
  id?: number;
  __component?: string;
  itemType?: "card" | "plain";
  maxItemsPerRow?: "one" | "two" | "three" | "four";
  containerProps?: CommonContainerPropsComponent;
  items?: StaticPagesGridCardComponent[];
}

export interface StaticPagesHeroComponent {
  id?: number;
  __component?: string;
  title?: string;
  body?: any;
  isCentered?: boolean;
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  buttonPrimaryTitle?: string;
  buttonPrimaryLink?: string;
  buttonSecondaryTitle?: string;
  buttonSecondaryLink?: string;
  containerProps?: CommonContainerPropsComponent;
  noBgGradient?: boolean;
}

export interface StaticPagesZigZagBlockComponent {
  id?: number;
  __component?: string;
  title?: string;
  body?: any;
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  media2?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  variant?: "left" | "right";
  isCentered?: boolean;
  containerProps?: CommonContainerPropsComponent;
}

export interface StaticPagesImageComponent {
  id?: number;
  __component?: string;
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  containerProps?: CommonContainerPropsComponent;
}

export interface StaticPagesItemsComponent {
  id?: number;
  title?: string;
  text?: string;
}

export interface StaticPagesFaqComponent {
  id?: number;
  __component?: string;
  title?: string;
  body?: any;
  items?: StaticPagesItemsComponent[];
}

export interface StaticPagesButtonBlockComponent {
  id?: number;
  __component?: string;
  buttonPrimaryTitle?: string;
  buttonPrimaryLink?: string;
  buttonSecondaryTitle?: string;
  buttonSecondaryLink?: string;
  containerProps?: CommonContainerPropsComponent;
}

export interface StaticPagesImageGalleryComponent {
  id?: number;
  __component?: string;
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    }[];
  };
  containerProps?: CommonContainerPropsComponent;
}

export interface StaticPagesFeatureCardComponent {
  id?: number;
  title?: string;
  body?: any;
  align?: "left" | "center";
  variant?: "bottom" | "top";
  dimming?: boolean;
  backgroundColor?: string;
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
}

export interface StaticPagesFeatureListComponent {
  id?: number;
  __component?: string;
  items?: StaticPagesFeatureCardComponent[];
  containerProps?: CommonContainerPropsComponent;
  scroll?: boolean;
  maxItemsPerRow?: "one" | "two" | "three" | "four";
}

export interface CommonSeoComponent {
  id?: number;
  title?: string;
  description?: string;
  keywords?: string;
  image?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              pathId?: number;
              parent?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              children?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              files?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: {
                          firstname?: string;
                          lastname?: string;
                          username?: string;
                          /** @format email */
                          email?: string;
                          resetPasswordToken?: string;
                          registrationToken?: string;
                          isActive?: boolean;
                          roles?: {
                            data?: {
                              id?: number;
                              attributes?: {
                                name?: string;
                                code?: string;
                                description?: string;
                                users?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  }[];
                                };
                                permissions?: {
                                  data?: {
                                    id?: number;
                                    attributes?: {
                                      action?: string;
                                      actionParameters?: any;
                                      subject?: string;
                                      properties?: any;
                                      conditions?: any;
                                      role?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      /** @format date-time */
                                      createdAt?: string;
                                      /** @format date-time */
                                      updatedAt?: string;
                                      createdBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      updatedBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                    };
                                  }[];
                                };
                                /** @format date-time */
                                createdAt?: string;
                                /** @format date-time */
                                updatedAt?: string;
                                createdBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                                updatedBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                              };
                            }[];
                          };
                          blocked?: boolean;
                          preferedLanguage?: string;
                          /** @format date-time */
                          createdAt?: string;
                          /** @format date-time */
                          updatedAt?: string;
                          createdBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          updatedBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                        };
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              path?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
}

export interface OwnerUnitCreationRequestRequest {
  data: {
    title?: string;
    unit_group_type?: string;
    /** @example "string or id" */
    city?: number | string;
    postcode?: string;
    city_district?: string;
    building_number?: string;
    entrance?: string;
    apartment_number?: string;
    residential_complex_name?: string;
    subway_station?: string;
    /** @format float */
    area?: number;
    rooms_count?: number;
    bedrooms_count?: number;
    beds_count?: number;
    bathrooms_count?: number;
    guests_count?: number;
    allows_animals?: boolean;
    allows_smoking?: boolean;
    floor_count?: number;
    has_elevator?: boolean;
    has_balcony?: boolean;
    description?: string;
    owner_type?: "individual" | "legal";
    owner_status?:
      | "owner"
      | "representative_general_poa"
      | "representative_other_poa"
      | "representative_other_poa_additional"
      | "legal_owner"
      | "legal_agent"
      | "legal_agency";
    request_status?: "new" | "signing_contract" | "rejected" | "ready_for_publish" | "corrections_pending";
    owner_id: string;
    beneficiary_name?: string;
    iban?: string;
    account_currency?: string;
    tin?: string;
    beneficiary_bank?: string;
    swift?: string;
    correspondent_account?: string;
    bank_code?: string;
    bank_tin?: string;
    bank_address?: string;
    bank_phone?: string;
    bank_fax?: string;
    /** @format email */
    bank_email?: string;
    owner_name?: string;
    owner_surname?: string;
    owner_patronymic?: string;
    owner_id_number?: string;
    owner_fin?: string;
    rep_name?: string;
    rep_surname?: string;
    rep_patronymic?: string;
    rep_id_number?: string;
    rep_fin?: string;
    owner_poa_number?: string;
    /** @format date */
    owner_poa_signature_date?: string;
    owner_phone?: string;
    legal_entity_name?: string;
    legal_tin?: string;
    legal_physical_adress?: string;
    legal_address?: string;
    legal_name?: string;
    legal_surname?: string;
    legal_patronymic?: string;
    legal_fin?: string;
    attributes?: (number | string)[];
    media?: (number | string)[];
    /** @example "string or id" */
    owner_passport_scan?: number | string;
    /** @example "string or id" */
    legal_passport_scan?: number | string;
    /** @example "string or id" */
    legal_tin_scan?: number | string;
    /** @example "string or id" */
    rep_pass_scan?: number | string;
    /** @example "string or id" */
    owner_poa_scan?: number | string;
    parking?: "none" | "underground" | "surface" | "paid" | "free" | "on_hotel_premises";
    floor?: string;
    agreement_id?: string;
    allows_children?: boolean;
    building_type?: "old_building" | "new_building";
    /** @example "string or id" */
    hotel_unit_group_view_type?: number | string;
    signed_agreement_id?: string;
    agreement_link?: string;
    signed_agreement_link?: string;
    language: "az" | "en" | "ru";
    finalized_agreement_id?: string;
    finalized_agreement_link?: string;
    /** @example "string or id" */
    finalized_agreement?: number | string;
    /** @example "string or id" */
    deed_scan?: number | string;
    /** @format email */
    owner_email?: string;
  };
}

export interface OwnerUnitCreationRequestListResponseDataItem {
  id?: number;
  attributes?: OwnerUnitCreationRequest;
}

export interface OwnerUnitCreationRequestListResponse {
  data?: OwnerUnitCreationRequestListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface OwnerUnitCreationRequest {
  title?: string;
  unit_group_type?: string;
  city?: {
    data?: {
      id?: number;
      attributes?: {
        title?: string;
        entity_id?: number;
        show_on_search?: boolean;
        show_on_personal_cabinet?: boolean;
        order?: number;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        /** @format date-time */
        publishedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: {
              firstname?: string;
              lastname?: string;
              username?: string;
              /** @format email */
              email?: string;
              resetPasswordToken?: string;
              registrationToken?: string;
              isActive?: boolean;
              roles?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    code?: string;
                    description?: string;
                    users?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    permissions?: {
                      data?: {
                        id?: number;
                        attributes?: {
                          action?: string;
                          actionParameters?: any;
                          subject?: string;
                          properties?: any;
                          conditions?: any;
                          role?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          /** @format date-time */
                          createdAt?: string;
                          /** @format date-time */
                          updatedAt?: string;
                          createdBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          updatedBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                        };
                      }[];
                    };
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              blocked?: boolean;
              preferedLanguage?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        localizations?: {
          data?: any[];
        };
        locale?: string;
      };
    };
  };
  postcode?: string;
  city_district?: string;
  building_number?: string;
  entrance?: string;
  apartment_number?: string;
  residential_complex_name?: string;
  subway_station?: string;
  /** @format float */
  area?: number;
  rooms_count?: number;
  bedrooms_count?: number;
  beds_count?: number;
  bathrooms_count?: number;
  guests_count?: number;
  allows_animals?: boolean;
  allows_smoking?: boolean;
  floor_count?: number;
  has_elevator?: boolean;
  has_balcony?: boolean;
  description?: string;
  owner_type?: "individual" | "legal";
  owner_status?:
    | "owner"
    | "representative_general_poa"
    | "representative_other_poa"
    | "representative_other_poa_additional"
    | "legal_owner"
    | "legal_agent"
    | "legal_agency";
  request_status?: "new" | "signing_contract" | "rejected" | "ready_for_publish" | "corrections_pending";
  owner_id: string;
  beneficiary_name?: string;
  iban?: string;
  account_currency?: string;
  tin?: string;
  beneficiary_bank?: string;
  swift?: string;
  correspondent_account?: string;
  bank_code?: string;
  bank_tin?: string;
  bank_address?: string;
  bank_phone?: string;
  bank_fax?: string;
  /** @format email */
  bank_email?: string;
  owner_name?: string;
  owner_surname?: string;
  owner_patronymic?: string;
  owner_id_number?: string;
  owner_fin?: string;
  rep_name?: string;
  rep_surname?: string;
  rep_patronymic?: string;
  rep_id_number?: string;
  rep_fin?: string;
  owner_poa_number?: string;
  /** @format date */
  owner_poa_signature_date?: string;
  owner_phone?: string;
  legal_entity_name?: string;
  legal_tin?: string;
  legal_physical_adress?: string;
  legal_address?: string;
  legal_name?: string;
  legal_surname?: string;
  legal_patronymic?: string;
  legal_fin?: string;
  attributes?: {
    data?: {
      id?: number;
      attributes?: {
        priority?: number;
        description?: string;
        title?: string;
        code?: string;
        entity_id?: number;
        icon?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              alternativeText?: string;
              caption?: string;
              width?: number;
              height?: number;
              formats?: any;
              hash?: string;
              ext?: string;
              mime?: string;
              /** @format float */
              size?: number;
              url?: string;
              previewUrl?: string;
              provider?: string;
              provider_metadata?: any;
              related?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              folder?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    pathId?: number;
                    parent?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    children?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    files?: {
                      data?: {
                        id?: number;
                        attributes?: {
                          name?: string;
                          alternativeText?: string;
                          caption?: string;
                          width?: number;
                          height?: number;
                          formats?: any;
                          hash?: string;
                          ext?: string;
                          mime?: string;
                          /** @format float */
                          size?: number;
                          url?: string;
                          previewUrl?: string;
                          provider?: string;
                          provider_metadata?: any;
                          related?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            }[];
                          };
                          folder?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          folderPath?: string;
                          /** @format date-time */
                          createdAt?: string;
                          /** @format date-time */
                          updatedAt?: string;
                          createdBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          updatedBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                        };
                      }[];
                    };
                    path?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                };
              };
              folderPath?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        full_title?: string;
        show_in_main_slider?: boolean;
        show_in_sidebar_filters?: boolean;
        show_in_attributes_on_mini_cards?: boolean;
        hide_on_card?: boolean;
        photo?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              alternativeText?: string;
              caption?: string;
              width?: number;
              height?: number;
              formats?: any;
              hash?: string;
              ext?: string;
              mime?: string;
              /** @format float */
              size?: number;
              url?: string;
              previewUrl?: string;
              provider?: string;
              provider_metadata?: any;
              related?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              folder?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              folderPath?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        show_in_personal_cabinet?: boolean;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        /** @format date-time */
        publishedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        localizations?: {
          data?: any[];
        };
        locale?: string;
      };
    }[];
  };
  media?: {
    data?: {
      id?: number;
      attributes?: {
        owner_id?: string;
        media?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              alternativeText?: string;
              caption?: string;
              width?: number;
              height?: number;
              formats?: any;
              hash?: string;
              ext?: string;
              mime?: string;
              /** @format float */
              size?: number;
              url?: string;
              previewUrl?: string;
              provider?: string;
              provider_metadata?: any;
              related?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              folder?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              folderPath?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        status?: "uploaded" | "not_uploaded";
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    }[];
  };
  owner_passport_scan?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  legal_passport_scan?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  legal_tin_scan?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  rep_pass_scan?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  owner_poa_scan?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  parking?: "none" | "underground" | "surface" | "paid" | "free" | "on_hotel_premises";
  floor?: string;
  agreement_id?: string;
  allows_children?: boolean;
  building_type?: "old_building" | "new_building";
  hotel_unit_group_view_type?: {
    data?: {
      id?: number;
      attributes?: {
        title?: string;
        entity_id?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        /** @format date-time */
        publishedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        localizations?: {
          data?: any[];
        };
        locale?: string;
      };
    };
  };
  signed_agreement_id?: string;
  agreement_link?: string;
  signed_agreement_link?: string;
  language: "az" | "en" | "ru";
  finalized_agreement_id?: string;
  finalized_agreement_link?: string;
  finalized_agreement?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  deed_scan?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  /** @format email */
  owner_email?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
}

export interface OwnerUnitCreationRequestResponseDataObject {
  id?: number;
  attributes?: OwnerUnitCreationRequest;
}

export interface OwnerUnitCreationRequestResponse {
  data?: OwnerUnitCreationRequestResponseDataObject;
  meta?: object;
}

export interface OwnerUnitCreationRequestMediaRequest {
  data: {
    owner_id: string;
    /** @example "string or id" */
    media?: number | string;
    status: "uploaded" | "not_uploaded";
  };
}

export interface OwnerUnitCreationRequestMediaListResponseDataItem {
  id?: number;
  attributes?: OwnerUnitCreationRequestMedia;
}

export interface OwnerUnitCreationRequestMediaListResponse {
  data?: OwnerUnitCreationRequestMediaListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface OwnerUnitCreationRequestMedia {
  owner_id: string;
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              pathId?: number;
              parent?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              children?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              files?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: {
                          firstname?: string;
                          lastname?: string;
                          username?: string;
                          /** @format email */
                          email?: string;
                          resetPasswordToken?: string;
                          registrationToken?: string;
                          isActive?: boolean;
                          roles?: {
                            data?: {
                              id?: number;
                              attributes?: {
                                name?: string;
                                code?: string;
                                description?: string;
                                users?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  }[];
                                };
                                permissions?: {
                                  data?: {
                                    id?: number;
                                    attributes?: {
                                      action?: string;
                                      actionParameters?: any;
                                      subject?: string;
                                      properties?: any;
                                      conditions?: any;
                                      role?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      /** @format date-time */
                                      createdAt?: string;
                                      /** @format date-time */
                                      updatedAt?: string;
                                      createdBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      updatedBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                    };
                                  }[];
                                };
                                /** @format date-time */
                                createdAt?: string;
                                /** @format date-time */
                                updatedAt?: string;
                                createdBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                                updatedBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                              };
                            }[];
                          };
                          blocked?: boolean;
                          preferedLanguage?: string;
                          /** @format date-time */
                          createdAt?: string;
                          /** @format date-time */
                          updatedAt?: string;
                          createdBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          updatedBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                        };
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              path?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  status: "uploaded" | "not_uploaded";
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
}

export interface OwnerUnitCreationRequestMediaResponseDataObject {
  id?: number;
  attributes?: OwnerUnitCreationRequestMedia;
}

export interface OwnerUnitCreationRequestMediaResponse {
  data?: OwnerUnitCreationRequestMediaResponseDataObject;
  meta?: object;
}

export interface PlainTextPageLocalizationRequest {
  title: string;
  content?: any;
  slug?: string;
  locale: string;
}

export interface PlainTextPageRequest {
  data: {
    title: string;
    content?: any;
    slug?: string;
    locale?: string;
  };
}

export interface PlainTextPageResponseDataObjectLocalized {
  id?: number;
  attributes?: PlainTextPage;
}

export interface PlainTextPageLocalizationResponse {
  data?: PlainTextPageResponseDataObjectLocalized;
  meta?: object;
}

export interface PlainTextPageListResponseDataItemLocalized {
  id?: number;
  attributes?: PlainTextPage;
}

export interface PlainTextPageLocalizationListResponse {
  data?: PlainTextPageListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface PlainTextPageListResponseDataItem {
  id?: number;
  attributes?: PlainTextPage;
}

export interface PlainTextPageListResponse {
  data?: PlainTextPageListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface PlainTextPage {
  title: string;
  content?: any;
  slug?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: {
        firstname?: string;
        lastname?: string;
        username?: string;
        /** @format email */
        email?: string;
        resetPasswordToken?: string;
        registrationToken?: string;
        isActive?: boolean;
        roles?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              code?: string;
              description?: string;
              users?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              permissions?: {
                data?: {
                  id?: number;
                  attributes?: {
                    action?: string;
                    actionParameters?: any;
                    subject?: string;
                    properties?: any;
                    conditions?: any;
                    role?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          }[];
        };
        blocked?: boolean;
        preferedLanguage?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: PlainTextPageListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface PlainTextPageResponseDataObject {
  id?: number;
  attributes?: PlainTextPage;
}

export interface PlainTextPageResponse {
  data?: PlainTextPageResponseDataObject;
  meta?: object;
}

export interface PromotionLabelLocalizationRequest {
  title?: string;
  backgroundColor?: "orange" | "purple" | "green";
  entity_id?: string;
  locale: string;
}

export interface PromotionLabelRequest {
  data: {
    title?: string;
    backgroundColor?: "orange" | "purple" | "green";
    entity_id?: string;
    locale?: string;
  };
}

export interface PromotionLabelResponseDataObjectLocalized {
  id?: number;
  attributes?: PromotionLabel;
}

export interface PromotionLabelLocalizationResponse {
  data?: PromotionLabelResponseDataObjectLocalized;
  meta?: object;
}

export interface PromotionLabelListResponseDataItemLocalized {
  id?: number;
  attributes?: PromotionLabel;
}

export interface PromotionLabelLocalizationListResponse {
  data?: PromotionLabelListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface PromotionLabelListResponseDataItem {
  id?: number;
  attributes?: PromotionLabel;
}

export interface PromotionLabelListResponse {
  data?: PromotionLabelListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface PromotionLabel {
  title?: string;
  backgroundColor?: "orange" | "purple" | "green";
  entity_id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: {
        firstname?: string;
        lastname?: string;
        username?: string;
        /** @format email */
        email?: string;
        resetPasswordToken?: string;
        registrationToken?: string;
        isActive?: boolean;
        roles?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              code?: string;
              description?: string;
              users?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              permissions?: {
                data?: {
                  id?: number;
                  attributes?: {
                    action?: string;
                    actionParameters?: any;
                    subject?: string;
                    properties?: any;
                    conditions?: any;
                    role?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          }[];
        };
        blocked?: boolean;
        preferedLanguage?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: PromotionLabelListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface PromotionLabelResponseDataObject {
  id?: number;
  attributes?: PromotionLabel;
}

export interface PromotionLabelResponse {
  data?: PromotionLabelResponseDataObject;
  meta?: object;
}

export interface RegionLocalizationRequest {
  title?: string;
  entity_id?: number;
  /** @example "string or id" */
  media?: number | string;
  /** @example "string or id" */
  static_page?: number | string;
  show_on_main_page?: boolean;
  locale: string;
}

export interface RegionRequest {
  data: {
    title?: string;
    entity_id?: number;
    /** @example "string or id" */
    media?: number | string;
    /** @example "string or id" */
    static_page?: number | string;
    show_on_main_page?: boolean;
    locale?: string;
  };
}

export interface RegionResponseDataObjectLocalized {
  id?: number;
  attributes?: Region;
}

export interface RegionLocalizationResponse {
  data?: RegionResponseDataObjectLocalized;
  meta?: object;
}

export interface RegionListResponseDataItemLocalized {
  id?: number;
  attributes?: Region;
}

export interface RegionLocalizationListResponse {
  data?: RegionListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface RegionListResponseDataItem {
  id?: number;
  attributes?: Region;
}

export interface RegionListResponse {
  data?: RegionListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface Region {
  title?: string;
  entity_id?: number;
  media?: {
    data?: {
      id?: number;
      attributes?: {
        name?: string;
        alternativeText?: string;
        caption?: string;
        width?: number;
        height?: number;
        formats?: any;
        hash?: string;
        ext?: string;
        mime?: string;
        /** @format float */
        size?: number;
        url?: string;
        previewUrl?: string;
        provider?: string;
        provider_metadata?: any;
        related?: {
          data?: {
            id?: number;
            attributes?: object;
          }[];
        };
        folder?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              pathId?: number;
              parent?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              children?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              files?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: {
                          firstname?: string;
                          lastname?: string;
                          username?: string;
                          /** @format email */
                          email?: string;
                          resetPasswordToken?: string;
                          registrationToken?: string;
                          isActive?: boolean;
                          roles?: {
                            data?: {
                              id?: number;
                              attributes?: {
                                name?: string;
                                code?: string;
                                description?: string;
                                users?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  }[];
                                };
                                permissions?: {
                                  data?: {
                                    id?: number;
                                    attributes?: {
                                      action?: string;
                                      actionParameters?: any;
                                      subject?: string;
                                      properties?: any;
                                      conditions?: any;
                                      role?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      /** @format date-time */
                                      createdAt?: string;
                                      /** @format date-time */
                                      updatedAt?: string;
                                      createdBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                      updatedBy?: {
                                        data?: {
                                          id?: number;
                                          attributes?: object;
                                        };
                                      };
                                    };
                                  }[];
                                };
                                /** @format date-time */
                                createdAt?: string;
                                /** @format date-time */
                                updatedAt?: string;
                                createdBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                                updatedBy?: {
                                  data?: {
                                    id?: number;
                                    attributes?: object;
                                  };
                                };
                              };
                            }[];
                          };
                          blocked?: boolean;
                          preferedLanguage?: string;
                          /** @format date-time */
                          createdAt?: string;
                          /** @format date-time */
                          updatedAt?: string;
                          createdBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                          updatedBy?: {
                            data?: {
                              id?: number;
                              attributes?: object;
                            };
                          };
                        };
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              path?: string;
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          };
        };
        folderPath?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  static_page?: {
    data?: {
      id?: number;
      attributes?: {
        title?: string;
        slug?: string;
        content?: (
          | {
              id?: number;
              __component?: string;
              text?: string;
              align?: "center" | "left" | "right";
              variant?: "h1" | "h2" | "h3";
            }
          | {
              id?: number;
              __component?: string;
              items?: {
                id?: number;
                text?: string;
                helpText?: string;
                value?: string;
                valueVariant?: "h3" | "h5";
              }[];
            }
          | {
              id?: number;
              __component?: string;
              items?: {
                id?: number;
                title?: string;
                text?: any;
                media?: {
                  data?: {
                    id?: number;
                    attributes?: {
                      name?: string;
                      alternativeText?: string;
                      caption?: string;
                      width?: number;
                      height?: number;
                      formats?: any;
                      hash?: string;
                      ext?: string;
                      mime?: string;
                      /** @format float */
                      size?: number;
                      url?: string;
                      previewUrl?: string;
                      provider?: string;
                      provider_metadata?: any;
                      related?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        }[];
                      };
                      folder?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        };
                      };
                      folderPath?: string;
                      /** @format date-time */
                      createdAt?: string;
                      /** @format date-time */
                      updatedAt?: string;
                      createdBy?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        };
                      };
                      updatedBy?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        };
                      };
                    };
                  };
                };
                media2?: {
                  data?: {
                    id?: number;
                    attributes?: {
                      name?: string;
                      alternativeText?: string;
                      caption?: string;
                      width?: number;
                      height?: number;
                      formats?: any;
                      hash?: string;
                      ext?: string;
                      mime?: string;
                      /** @format float */
                      size?: number;
                      url?: string;
                      previewUrl?: string;
                      provider?: string;
                      provider_metadata?: any;
                      related?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        }[];
                      };
                      folder?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        };
                      };
                      folderPath?: string;
                      /** @format date-time */
                      createdAt?: string;
                      /** @format date-time */
                      updatedAt?: string;
                      createdBy?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        };
                      };
                      updatedBy?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        };
                      };
                    };
                  };
                };
                variant?: "left" | "right";
                isCentered?: boolean;
              }[];
            }
          | {
              id?: number;
              __component?: string;
              filterLink?: string;
            }
          | {
              id?: number;
              __component?: string;
              content?: any;
              textAlign?: "center" | "left" | "right";
              containerProps?: {
                id?: number;
                maxWidth?: "md" | "lg" | "xl" | "full";
                backgroundColor?:
                  | "primary.main"
                  | "primary.dark"
                  | "primary.darker"
                  | "secondary.main"
                  | "secondary.dark"
                  | "secondary.darker";
                /** @format float */
                marginTop?: number;
                /** @format float */
                marginBottom?: number;
                /** @format float */
                paddingTop?: number;
                /** @format float */
                paddingBottom?: number;
              };
            }
          | {
              id?: number;
              __component?: string;
              items?: {
                id?: number;
                media?: {
                  data?: {
                    id?: number;
                    attributes?: {
                      name?: string;
                      alternativeText?: string;
                      caption?: string;
                      width?: number;
                      height?: number;
                      formats?: any;
                      hash?: string;
                      ext?: string;
                      mime?: string;
                      /** @format float */
                      size?: number;
                      url?: string;
                      previewUrl?: string;
                      provider?: string;
                      provider_metadata?: any;
                      related?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        }[];
                      };
                      folder?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        };
                      };
                      folderPath?: string;
                      /** @format date-time */
                      createdAt?: string;
                      /** @format date-time */
                      updatedAt?: string;
                      createdBy?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        };
                      };
                      updatedBy?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        };
                      };
                    };
                  };
                };
                title?: string;
                subtitle?: string;
                text?: any;
                withLogo?: boolean;
                textAlign?: "center" | "left" | "right";
                ctaTitle?: string;
                ctaLink?: string;
                textDark?: boolean;
                ctaColor?: "primary" | "secondary" | "error" | "success";
              }[];
            }
          | {
              id?: number;
              __component?: string;
              title?: string;
              body?: any;
              variant?: "h1" | "h2" | "h3";
              isCentered?: boolean;
              media?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                };
              };
              containerProps?: {
                id?: number;
                maxWidth?: "md" | "lg" | "xl" | "full";
                backgroundColor?:
                  | "primary.main"
                  | "primary.dark"
                  | "primary.darker"
                  | "secondary.main"
                  | "secondary.dark"
                  | "secondary.darker";
                /** @format float */
                marginTop?: number;
                /** @format float */
                marginBottom?: number;
                /** @format float */
                paddingTop?: number;
                /** @format float */
                paddingBottom?: number;
              };
            }
          | {
              id?: number;
              __component?: string;
              title?: string;
              name?: string;
              jobTitle?: string;
              variant?: "left" | "right" | "withBorder";
              media?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                };
              };
              containerProps?: {
                id?: number;
                maxWidth?: "md" | "lg" | "xl" | "full";
                backgroundColor?:
                  | "primary.main"
                  | "primary.dark"
                  | "primary.darker"
                  | "secondary.main"
                  | "secondary.dark"
                  | "secondary.darker";
                /** @format float */
                marginTop?: number;
                /** @format float */
                marginBottom?: number;
                /** @format float */
                paddingTop?: number;
                /** @format float */
                paddingBottom?: number;
              };
              body?: any;
              isCentered?: boolean;
              bgStyle?: "primary" | "secondary";
            }
          | {
              id?: number;
              __component?: string;
              itemType?: "card" | "plain";
              maxItemsPerRow?: "one" | "two" | "three" | "four";
              containerProps?: {
                id?: number;
                maxWidth?: "md" | "lg" | "xl" | "full";
                backgroundColor?:
                  | "primary.main"
                  | "primary.dark"
                  | "primary.darker"
                  | "secondary.main"
                  | "secondary.dark"
                  | "secondary.darker";
                /** @format float */
                marginTop?: number;
                /** @format float */
                marginBottom?: number;
                /** @format float */
                paddingTop?: number;
                /** @format float */
                paddingBottom?: number;
              };
              items?: {
                id?: number;
                title?: string;
                media?: {
                  data?: {
                    id?: number;
                    attributes?: {
                      name?: string;
                      alternativeText?: string;
                      caption?: string;
                      width?: number;
                      height?: number;
                      formats?: any;
                      hash?: string;
                      ext?: string;
                      mime?: string;
                      /** @format float */
                      size?: number;
                      url?: string;
                      previewUrl?: string;
                      provider?: string;
                      provider_metadata?: any;
                      related?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        }[];
                      };
                      folder?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        };
                      };
                      folderPath?: string;
                      /** @format date-time */
                      createdAt?: string;
                      /** @format date-time */
                      updatedAt?: string;
                      createdBy?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        };
                      };
                      updatedBy?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        };
                      };
                    };
                  };
                };
                body?: any;
                icon?: string;
                isCentered?: boolean;
                variant?: "h3" | "h5";
                backgroundColor?: string;
                linkText?: string;
                linkUrl?: string;
              }[];
            }
          | {
              id?: number;
              __component?: string;
              title?: string;
              media?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                };
              };
              body?: any;
              icon?: string;
              isCentered?: boolean;
              variant?: "h3" | "h5";
              backgroundColor?: string;
              linkText?: string;
              linkUrl?: string;
            }
          | {
              id?: number;
              __component?: string;
              title?: string;
              body?: any;
              isCentered?: boolean;
              media?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                };
              };
              buttonPrimaryTitle?: string;
              buttonPrimaryLink?: string;
              buttonSecondaryTitle?: string;
              buttonSecondaryLink?: string;
              containerProps?: {
                id?: number;
                maxWidth?: "md" | "lg" | "xl" | "full";
                backgroundColor?:
                  | "primary.main"
                  | "primary.dark"
                  | "primary.darker"
                  | "secondary.main"
                  | "secondary.dark"
                  | "secondary.darker";
                /** @format float */
                marginTop?: number;
                /** @format float */
                marginBottom?: number;
                /** @format float */
                paddingTop?: number;
                /** @format float */
                paddingBottom?: number;
              };
              noBgGradient?: boolean;
            }
          | {
              id?: number;
              __component?: string;
              title?: string;
              body?: any;
              media?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                };
              };
              media2?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                };
              };
              variant?: "left" | "right";
              isCentered?: boolean;
              containerProps?: {
                id?: number;
                maxWidth?: "md" | "lg" | "xl" | "full";
                backgroundColor?:
                  | "primary.main"
                  | "primary.dark"
                  | "primary.darker"
                  | "secondary.main"
                  | "secondary.dark"
                  | "secondary.darker";
                /** @format float */
                marginTop?: number;
                /** @format float */
                marginBottom?: number;
                /** @format float */
                paddingTop?: number;
                /** @format float */
                paddingBottom?: number;
              };
            }
          | {
              id?: number;
              __component?: string;
              media?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                };
              };
              containerProps?: {
                id?: number;
                maxWidth?: "md" | "lg" | "xl" | "full";
                backgroundColor?:
                  | "primary.main"
                  | "primary.dark"
                  | "primary.darker"
                  | "secondary.main"
                  | "secondary.dark"
                  | "secondary.darker";
                /** @format float */
                marginTop?: number;
                /** @format float */
                marginBottom?: number;
                /** @format float */
                paddingTop?: number;
                /** @format float */
                paddingBottom?: number;
              };
            }
          | {
              id?: number;
              __component?: string;
              title?: string;
              body?: any;
              items?: {
                id?: number;
                title?: string;
                text?: string;
              }[];
            }
          | {
              id?: number;
              __component?: string;
              buttonPrimaryTitle?: string;
              buttonPrimaryLink?: string;
              buttonSecondaryTitle?: string;
              buttonSecondaryLink?: string;
              containerProps?: {
                id?: number;
                maxWidth?: "md" | "lg" | "xl" | "full";
                backgroundColor?:
                  | "primary.main"
                  | "primary.dark"
                  | "primary.darker"
                  | "secondary.main"
                  | "secondary.dark"
                  | "secondary.darker";
                /** @format float */
                marginTop?: number;
                /** @format float */
                marginBottom?: number;
                /** @format float */
                paddingTop?: number;
                /** @format float */
                paddingBottom?: number;
              };
            }
          | {
              id?: number;
              __component?: string;
              media?: {
                data?: {
                  id?: number;
                  attributes?: {
                    name?: string;
                    alternativeText?: string;
                    caption?: string;
                    width?: number;
                    height?: number;
                    formats?: any;
                    hash?: string;
                    ext?: string;
                    mime?: string;
                    /** @format float */
                    size?: number;
                    url?: string;
                    previewUrl?: string;
                    provider?: string;
                    provider_metadata?: any;
                    related?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      }[];
                    };
                    folder?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    folderPath?: string;
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              containerProps?: {
                id?: number;
                maxWidth?: "md" | "lg" | "xl" | "full";
                backgroundColor?:
                  | "primary.main"
                  | "primary.dark"
                  | "primary.darker"
                  | "secondary.main"
                  | "secondary.dark"
                  | "secondary.darker";
                /** @format float */
                marginTop?: number;
                /** @format float */
                marginBottom?: number;
                /** @format float */
                paddingTop?: number;
                /** @format float */
                paddingBottom?: number;
              };
            }
          | {
              id?: number;
              __component?: string;
              items?: {
                id?: number;
                title?: string;
                body?: any;
                align?: "left" | "center";
                variant?: "bottom" | "top";
                dimming?: boolean;
                backgroundColor?: string;
                media?: {
                  data?: {
                    id?: number;
                    attributes?: {
                      name?: string;
                      alternativeText?: string;
                      caption?: string;
                      width?: number;
                      height?: number;
                      formats?: any;
                      hash?: string;
                      ext?: string;
                      mime?: string;
                      /** @format float */
                      size?: number;
                      url?: string;
                      previewUrl?: string;
                      provider?: string;
                      provider_metadata?: any;
                      related?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        }[];
                      };
                      folder?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        };
                      };
                      folderPath?: string;
                      /** @format date-time */
                      createdAt?: string;
                      /** @format date-time */
                      updatedAt?: string;
                      createdBy?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        };
                      };
                      updatedBy?: {
                        data?: {
                          id?: number;
                          attributes?: object;
                        };
                      };
                    };
                  };
                };
              }[];
              containerProps?: {
                id?: number;
                maxWidth?: "md" | "lg" | "xl" | "full";
                backgroundColor?:
                  | "primary.main"
                  | "primary.dark"
                  | "primary.darker"
                  | "secondary.main"
                  | "secondary.dark"
                  | "secondary.darker";
                /** @format float */
                marginTop?: number;
                /** @format float */
                marginBottom?: number;
                /** @format float */
                paddingTop?: number;
                /** @format float */
                paddingBottom?: number;
              };
              scroll?: boolean;
              maxItemsPerRow?: "one" | "two" | "three" | "four";
            }
        )[];
        layout?: "default" | "landing";
        seo?: {
          id?: number;
          title?: string;
          description?: string;
          keywords?: string;
          image?: {
            data?: {
              id?: number;
              attributes?: {
                name?: string;
                alternativeText?: string;
                caption?: string;
                width?: number;
                height?: number;
                formats?: any;
                hash?: string;
                ext?: string;
                mime?: string;
                /** @format float */
                size?: number;
                url?: string;
                previewUrl?: string;
                provider?: string;
                provider_metadata?: any;
                related?: {
                  data?: {
                    id?: number;
                    attributes?: object;
                  }[];
                };
                folder?: {
                  data?: {
                    id?: number;
                    attributes?: object;
                  };
                };
                folderPath?: string;
                /** @format date-time */
                createdAt?: string;
                /** @format date-time */
                updatedAt?: string;
                createdBy?: {
                  data?: {
                    id?: number;
                    attributes?: object;
                  };
                };
                updatedBy?: {
                  data?: {
                    id?: number;
                    attributes?: object;
                  };
                };
              };
            };
          };
        };
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        /** @format date-time */
        publishedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        localizations?: {
          data?: any[];
        };
        locale?: string;
      };
    };
  };
  show_on_main_page?: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: RegionListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface RegionResponseDataObject {
  id?: number;
  attributes?: Region;
}

export interface RegionResponse {
  data?: RegionResponseDataObject;
  meta?: object;
}

export interface RestaurantLocalizationRequest {
  title?: string;
  entity_id?: string;
  locale: string;
}

export interface RestaurantRequest {
  data: {
    title?: string;
    entity_id?: string;
    locale?: string;
  };
}

export interface RestaurantResponseDataObjectLocalized {
  id?: number;
  attributes?: Restaurant;
}

export interface RestaurantLocalizationResponse {
  data?: RestaurantResponseDataObjectLocalized;
  meta?: object;
}

export interface RestaurantListResponseDataItemLocalized {
  id?: number;
  attributes?: Restaurant;
}

export interface RestaurantLocalizationListResponse {
  data?: RestaurantListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface RestaurantListResponseDataItem {
  id?: number;
  attributes?: Restaurant;
}

export interface RestaurantListResponse {
  data?: RestaurantListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface Restaurant {
  title?: string;
  entity_id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: {
        firstname?: string;
        lastname?: string;
        username?: string;
        /** @format email */
        email?: string;
        resetPasswordToken?: string;
        registrationToken?: string;
        isActive?: boolean;
        roles?: {
          data?: {
            id?: number;
            attributes?: {
              name?: string;
              code?: string;
              description?: string;
              users?: {
                data?: {
                  id?: number;
                  attributes?: object;
                }[];
              };
              permissions?: {
                data?: {
                  id?: number;
                  attributes?: {
                    action?: string;
                    actionParameters?: any;
                    subject?: string;
                    properties?: any;
                    conditions?: any;
                    role?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    /** @format date-time */
                    createdAt?: string;
                    /** @format date-time */
                    updatedAt?: string;
                    createdBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                    updatedBy?: {
                      data?: {
                        id?: number;
                        attributes?: object;
                      };
                    };
                  };
                }[];
              };
              /** @format date-time */
              createdAt?: string;
              /** @format date-time */
              updatedAt?: string;
              createdBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
              updatedBy?: {
                data?: {
                  id?: number;
                  attributes?: object;
                };
              };
            };
          }[];
        };
        blocked?: boolean;
        preferedLanguage?: string;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        createdBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
        updatedBy?: {
          data?: {
            id?: number;
            attributes?: object;
          };
        };
      };
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: RestaurantListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface RestaurantResponseDataObject {
  id?: number;
  attributes?: Restaurant;
}

export interface RestaurantResponse {
  data?: RestaurantResponseDataObject;
  meta?: object;
}

export interface SeoLocalizationRequest {
  url?: string;
  seo?: CommonSeoComponent;
  locale: string;
}

export interface SeoRequest {
  data: {
    url?: string;
    seo?: CommonSeoComponent;
    locale?: string;
  };
}

export interface SeoResponseDataObjectLocalized {
  id?: number;
  attributes?: Seo;
}

export interface SeoLocalizationResponse {
  data?: SeoResponseDataObjectLocalized;
  meta?: object;
}

export interface SeoListResponseDataItemLocalized {
  id?: number;
  attributes?: Seo;
}

export interface SeoLocalizationListResponse {
  data?: SeoListResponseDataItemLocalized[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface SeoListResponseDataItem {
  id?: number;
  attributes?: Seo;
}

export interface SeoListResponse {
  data?: SeoListResponseDataItem[];
  meta?: {
    pagination?: {
      page?: number;
      /** @min 25 */
      pageSize?: number;
      /** @max 1 */
      pageCount?: number;
      total?: number;
    };
  };
}

export interface Seo {
  url?: string;
  seo?: CommonSeoComponent;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  publishedAt?: string;
  createdBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  updatedBy?: {
    data?: {
      id?: number;
      attributes?: object;
    };
  };
  localizations?: {
    data?: SeoListResponseDataItemLocalized[];
  };
  locale?: string;
}

export interface SeoResponseDataObject {
  id?: number;
  attributes?: Seo;
}

export interface SeoResponse {
  data?: SeoResponseDataObject;
  meta?: object;
}

export interface UploadFile {
  id?: number;
  name?: string;
  alternativeText?: string;
  caption?: string;
  /** @format integer */
  width?: number;
  /** @format integer */
  height?: number;
  formats?: number;
  hash?: string;
  ext?: string;
  mime?: string;
  /** @format double */
  size?: number;
  url?: string;
  previewUrl?: string;
  provider?: string;
  provider_metadata?: object;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
}

export interface UsersPermissionsRole {
  id?: number;
  name?: string;
  description?: string;
  type?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
}

export interface UsersPermissionsUser {
  /** @example 1 */
  id?: number;
  /** @example "foo.bar" */
  username?: string;
  /** @example "foo.bar@strapi.io" */
  email?: string;
  /** @example "local" */
  provider?: string;
  /** @example true */
  confirmed?: boolean;
  /** @example false */
  blocked?: boolean;
  /**
   * @format date-time
   * @example "2022-06-02T08:32:06.258Z"
   */
  createdAt?: string;
  /**
   * @format date-time
   * @example "2022-06-02T08:32:06.267Z"
   */
  updatedAt?: string;
}

export interface UsersPermissionsUserRegistration {
  /** @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c" */
  jwt?: string;
  user?: UsersPermissionsUser;
}

export type UsersPermissionsPermissionsTree = Record<
  string,
  {
    /** every controller of the api */
    controllers?: Record<
      string,
      Record<
        string,
        {
          enabled?: boolean;
          policy?: string;
        }
      >
    >;
  }
>;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/api" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title DOCUMENTATION
 * @version 1.0.0
 * @license Apache 2.0 (https://www.apache.org/licenses/LICENSE-2.0.html)
 * @termsOfService YOUR_TERMS_OF_SERVICE_URL
 * @baseUrl /api
 * @externalDocs https://docs.strapi.io/developer-docs/latest/getting-started/introduction.html
 * @contact TEAM <contact-email@something.io> (mywebsite.io)
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  bannerPromos = {
    /**
     * No description
     *
     * @tags Banner-promo
     * @name GetBannerPromos
     * @request GET:/banner-promos
     * @secure
     */
    getBannerPromos: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BannerPromoListResponse, Error>({
        path: `/banner-promos`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banner-promo
     * @name PostBannerPromos
     * @request POST:/banner-promos
     * @secure
     */
    postBannerPromos: (data: BannerPromoRequest, params: RequestParams = {}) =>
      this.request<BannerPromoResponse, Error>({
        path: `/banner-promos`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banner-promo
     * @name GetBannerPromosId
     * @request GET:/banner-promos/{id}
     * @secure
     */
    getBannerPromosId: (id: number, params: RequestParams = {}) =>
      this.request<BannerPromoResponse, Error>({
        path: `/banner-promos/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banner-promo
     * @name PutBannerPromosId
     * @request PUT:/banner-promos/{id}
     * @secure
     */
    putBannerPromosId: (id: number, data: BannerPromoRequest, params: RequestParams = {}) =>
      this.request<BannerPromoResponse, Error>({
        path: `/banner-promos/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banner-promo
     * @name DeleteBannerPromosId
     * @request DELETE:/banner-promos/{id}
     * @secure
     */
    deleteBannerPromosId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/banner-promos/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banner-promo
     * @name PostBannerPromosIdLocalizations
     * @request POST:/banner-promos/{id}/localizations
     * @secure
     */
    postBannerPromosIdLocalizations: (id: number, data: BannerPromoLocalizationRequest, params: RequestParams = {}) =>
      this.request<BannerPromoLocalizationResponse, Error>({
        path: `/banner-promos/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  bannerSearches = {
    /**
     * No description
     *
     * @tags Banner-search
     * @name GetBannerSearches
     * @request GET:/banner-searches
     * @secure
     */
    getBannerSearches: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BannerSearchListResponse, Error>({
        path: `/banner-searches`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banner-search
     * @name PostBannerSearches
     * @request POST:/banner-searches
     * @secure
     */
    postBannerSearches: (data: BannerSearchRequest, params: RequestParams = {}) =>
      this.request<BannerSearchResponse, Error>({
        path: `/banner-searches`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banner-search
     * @name GetBannerSearchesId
     * @request GET:/banner-searches/{id}
     * @secure
     */
    getBannerSearchesId: (id: number, params: RequestParams = {}) =>
      this.request<BannerSearchResponse, Error>({
        path: `/banner-searches/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banner-search
     * @name PutBannerSearchesId
     * @request PUT:/banner-searches/{id}
     * @secure
     */
    putBannerSearchesId: (id: number, data: BannerSearchRequest, params: RequestParams = {}) =>
      this.request<BannerSearchResponse, Error>({
        path: `/banner-searches/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banner-search
     * @name DeleteBannerSearchesId
     * @request DELETE:/banner-searches/{id}
     * @secure
     */
    deleteBannerSearchesId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/banner-searches/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banner-search
     * @name PostBannerSearchesIdLocalizations
     * @request POST:/banner-searches/{id}/localizations
     * @secure
     */
    postBannerSearchesIdLocalizations: (
      id: number,
      data: BannerSearchLocalizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<BannerSearchLocalizationResponse, Error>({
        path: `/banner-searches/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  bookingOwnerDenyReasons = {
    /**
     * No description
     *
     * @tags Booking-owner-deny-reason
     * @name GetBookingOwnerDenyReasons
     * @request GET:/booking-owner-deny-reasons
     * @secure
     */
    getBookingOwnerDenyReasons: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BookingOwnerDenyReasonListResponse, Error>({
        path: `/booking-owner-deny-reasons`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking-owner-deny-reason
     * @name PostBookingOwnerDenyReasons
     * @request POST:/booking-owner-deny-reasons
     * @secure
     */
    postBookingOwnerDenyReasons: (data: BookingOwnerDenyReasonRequest, params: RequestParams = {}) =>
      this.request<BookingOwnerDenyReasonResponse, Error>({
        path: `/booking-owner-deny-reasons`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking-owner-deny-reason
     * @name GetBookingOwnerDenyReasonsId
     * @request GET:/booking-owner-deny-reasons/{id}
     * @secure
     */
    getBookingOwnerDenyReasonsId: (id: number, params: RequestParams = {}) =>
      this.request<BookingOwnerDenyReasonResponse, Error>({
        path: `/booking-owner-deny-reasons/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking-owner-deny-reason
     * @name PutBookingOwnerDenyReasonsId
     * @request PUT:/booking-owner-deny-reasons/{id}
     * @secure
     */
    putBookingOwnerDenyReasonsId: (id: number, data: BookingOwnerDenyReasonRequest, params: RequestParams = {}) =>
      this.request<BookingOwnerDenyReasonResponse, Error>({
        path: `/booking-owner-deny-reasons/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking-owner-deny-reason
     * @name DeleteBookingOwnerDenyReasonsId
     * @request DELETE:/booking-owner-deny-reasons/{id}
     * @secure
     */
    deleteBookingOwnerDenyReasonsId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/booking-owner-deny-reasons/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking-owner-deny-reason
     * @name PostBookingOwnerDenyReasonsIdLocalizations
     * @request POST:/booking-owner-deny-reasons/{id}/localizations
     * @secure
     */
    postBookingOwnerDenyReasonsIdLocalizations: (
      id: number,
      data: BookingOwnerDenyReasonLocalizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<BookingOwnerDenyReasonLocalizationResponse, Error>({
        path: `/booking-owner-deny-reasons/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  cities = {
    /**
     * No description
     *
     * @tags City
     * @name GetCities
     * @request GET:/cities
     * @secure
     */
    getCities: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CityListResponse, Error>({
        path: `/cities`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags City
     * @name PostCities
     * @request POST:/cities
     * @secure
     */
    postCities: (data: CityRequest, params: RequestParams = {}) =>
      this.request<CityResponse, Error>({
        path: `/cities`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags City
     * @name GetCitiesId
     * @request GET:/cities/{id}
     * @secure
     */
    getCitiesId: (id: number, params: RequestParams = {}) =>
      this.request<CityResponse, Error>({
        path: `/cities/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags City
     * @name PutCitiesId
     * @request PUT:/cities/{id}
     * @secure
     */
    putCitiesId: (id: number, data: CityRequest, params: RequestParams = {}) =>
      this.request<CityResponse, Error>({
        path: `/cities/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags City
     * @name DeleteCitiesId
     * @request DELETE:/cities/{id}
     * @secure
     */
    deleteCitiesId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/cities/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags City
     * @name PostCitiesIdLocalizations
     * @request POST:/cities/{id}/localizations
     * @secure
     */
    postCitiesIdLocalizations: (id: number, data: CityLocalizationRequest, params: RequestParams = {}) =>
      this.request<CityLocalizationResponse, Error>({
        path: `/cities/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  cityDistricts = {
    /**
     * No description
     *
     * @tags City-district
     * @name GetCityDistricts
     * @request GET:/city-districts
     * @secure
     */
    getCityDistricts: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CityDistrictListResponse, Error>({
        path: `/city-districts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags City-district
     * @name PostCityDistricts
     * @request POST:/city-districts
     * @secure
     */
    postCityDistricts: (data: CityDistrictRequest, params: RequestParams = {}) =>
      this.request<CityDistrictResponse, Error>({
        path: `/city-districts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags City-district
     * @name GetCityDistrictsId
     * @request GET:/city-districts/{id}
     * @secure
     */
    getCityDistrictsId: (id: number, params: RequestParams = {}) =>
      this.request<CityDistrictResponse, Error>({
        path: `/city-districts/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags City-district
     * @name PutCityDistrictsId
     * @request PUT:/city-districts/{id}
     * @secure
     */
    putCityDistrictsId: (id: number, data: CityDistrictRequest, params: RequestParams = {}) =>
      this.request<CityDistrictResponse, Error>({
        path: `/city-districts/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags City-district
     * @name DeleteCityDistrictsId
     * @request DELETE:/city-districts/{id}
     * @secure
     */
    deleteCityDistrictsId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/city-districts/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags City-district
     * @name PostCityDistrictsIdLocalizations
     * @request POST:/city-districts/{id}/localizations
     * @secure
     */
    postCityDistrictsIdLocalizations: (id: number, data: CityDistrictLocalizationRequest, params: RequestParams = {}) =>
      this.request<CityDistrictLocalizationResponse, Error>({
        path: `/city-districts/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  countries = {
    /**
     * No description
     *
     * @tags Country
     * @name GetCountries
     * @request GET:/countries
     * @secure
     */
    getCountries: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CountryListResponse, Error>({
        path: `/countries`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Country
     * @name PostCountries
     * @request POST:/countries
     * @secure
     */
    postCountries: (data: CountryRequest, params: RequestParams = {}) =>
      this.request<CountryResponse, Error>({
        path: `/countries`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Country
     * @name GetCountriesId
     * @request GET:/countries/{id}
     * @secure
     */
    getCountriesId: (id: number, params: RequestParams = {}) =>
      this.request<CountryResponse, Error>({
        path: `/countries/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Country
     * @name PutCountriesId
     * @request PUT:/countries/{id}
     * @secure
     */
    putCountriesId: (id: number, data: CountryRequest, params: RequestParams = {}) =>
      this.request<CountryResponse, Error>({
        path: `/countries/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Country
     * @name DeleteCountriesId
     * @request DELETE:/countries/{id}
     * @secure
     */
    deleteCountriesId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/countries/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Country
     * @name PostCountriesIdLocalizations
     * @request POST:/countries/{id}/localizations
     * @secure
     */
    postCountriesIdLocalizations: (id: number, data: CountryLocalizationRequest, params: RequestParams = {}) =>
      this.request<CountryLocalizationResponse, Error>({
        path: `/countries/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  headerBanners = {
    /**
     * No description
     *
     * @tags Header-banner
     * @name GetHeaderBanners
     * @request GET:/header-banners
     * @secure
     */
    getHeaderBanners: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HeaderBannerListResponse, Error>({
        path: `/header-banners`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Header-banner
     * @name PostHeaderBanners
     * @request POST:/header-banners
     * @secure
     */
    postHeaderBanners: (data: HeaderBannerRequest, params: RequestParams = {}) =>
      this.request<HeaderBannerResponse, Error>({
        path: `/header-banners`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Header-banner
     * @name GetHeaderBannersId
     * @request GET:/header-banners/{id}
     * @secure
     */
    getHeaderBannersId: (id: number, params: RequestParams = {}) =>
      this.request<HeaderBannerResponse, Error>({
        path: `/header-banners/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Header-banner
     * @name PutHeaderBannersId
     * @request PUT:/header-banners/{id}
     * @secure
     */
    putHeaderBannersId: (id: number, data: HeaderBannerRequest, params: RequestParams = {}) =>
      this.request<HeaderBannerResponse, Error>({
        path: `/header-banners/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Header-banner
     * @name DeleteHeaderBannersId
     * @request DELETE:/header-banners/{id}
     * @secure
     */
    deleteHeaderBannersId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/header-banners/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Header-banner
     * @name PostHeaderBannersIdLocalizations
     * @request POST:/header-banners/{id}/localizations
     * @secure
     */
    postHeaderBannersIdLocalizations: (id: number, data: HeaderBannerLocalizationRequest, params: RequestParams = {}) =>
      this.request<HeaderBannerLocalizationResponse, Error>({
        path: `/header-banners/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  hotels = {
    /**
     * No description
     *
     * @tags Hotel
     * @name GetHotels
     * @request GET:/hotels
     * @secure
     */
    getHotels: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HotelListResponse, Error>({
        path: `/hotels`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel
     * @name PostHotels
     * @request POST:/hotels
     * @secure
     */
    postHotels: (data: HotelRequest, params: RequestParams = {}) =>
      this.request<HotelResponse, Error>({
        path: `/hotels`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel
     * @name GetHotelsId
     * @request GET:/hotels/{id}
     * @secure
     */
    getHotelsId: (id: number, params: RequestParams = {}) =>
      this.request<HotelResponse, Error>({
        path: `/hotels/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel
     * @name PutHotelsId
     * @request PUT:/hotels/{id}
     * @secure
     */
    putHotelsId: (id: number, data: HotelRequest, params: RequestParams = {}) =>
      this.request<HotelResponse, Error>({
        path: `/hotels/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel
     * @name DeleteHotelsId
     * @request DELETE:/hotels/{id}
     * @secure
     */
    deleteHotelsId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/hotels/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel
     * @name PostHotelsIdLocalizations
     * @request POST:/hotels/{id}/localizations
     * @secure
     */
    postHotelsIdLocalizations: (id: number, data: HotelLocalizationRequest, params: RequestParams = {}) =>
      this.request<HotelLocalizationResponse, Error>({
        path: `/hotels/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  hotelAdditionalServices = {
    /**
     * No description
     *
     * @tags Hotel-additional-service
     * @name GetHotelAdditionalServices
     * @request GET:/hotel-additional-services
     * @secure
     */
    getHotelAdditionalServices: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HotelAdditionalServiceListResponse, Error>({
        path: `/hotel-additional-services`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-additional-service
     * @name PostHotelAdditionalServices
     * @request POST:/hotel-additional-services
     * @secure
     */
    postHotelAdditionalServices: (data: HotelAdditionalServiceRequest, params: RequestParams = {}) =>
      this.request<HotelAdditionalServiceResponse, Error>({
        path: `/hotel-additional-services`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-additional-service
     * @name GetHotelAdditionalServicesId
     * @request GET:/hotel-additional-services/{id}
     * @secure
     */
    getHotelAdditionalServicesId: (id: number, params: RequestParams = {}) =>
      this.request<HotelAdditionalServiceResponse, Error>({
        path: `/hotel-additional-services/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-additional-service
     * @name PutHotelAdditionalServicesId
     * @request PUT:/hotel-additional-services/{id}
     * @secure
     */
    putHotelAdditionalServicesId: (id: number, data: HotelAdditionalServiceRequest, params: RequestParams = {}) =>
      this.request<HotelAdditionalServiceResponse, Error>({
        path: `/hotel-additional-services/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-additional-service
     * @name DeleteHotelAdditionalServicesId
     * @request DELETE:/hotel-additional-services/{id}
     * @secure
     */
    deleteHotelAdditionalServicesId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/hotel-additional-services/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-additional-service
     * @name PostHotelAdditionalServicesIdLocalizations
     * @request POST:/hotel-additional-services/{id}/localizations
     * @secure
     */
    postHotelAdditionalServicesIdLocalizations: (
      id: number,
      data: HotelAdditionalServiceLocalizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<HotelAdditionalServiceLocalizationResponse, Error>({
        path: `/hotel-additional-services/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  hotelAttributes = {
    /**
     * No description
     *
     * @tags Hotel-attribute
     * @name GetHotelAttributes
     * @request GET:/hotel-attributes
     * @secure
     */
    getHotelAttributes: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HotelAttributeListResponse, Error>({
        path: `/hotel-attributes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-attribute
     * @name PostHotelAttributes
     * @request POST:/hotel-attributes
     * @secure
     */
    postHotelAttributes: (data: HotelAttributeRequest, params: RequestParams = {}) =>
      this.request<HotelAttributeResponse, Error>({
        path: `/hotel-attributes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-attribute
     * @name GetHotelAttributesId
     * @request GET:/hotel-attributes/{id}
     * @secure
     */
    getHotelAttributesId: (id: number, params: RequestParams = {}) =>
      this.request<HotelAttributeResponse, Error>({
        path: `/hotel-attributes/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-attribute
     * @name PutHotelAttributesId
     * @request PUT:/hotel-attributes/{id}
     * @secure
     */
    putHotelAttributesId: (id: number, data: HotelAttributeRequest, params: RequestParams = {}) =>
      this.request<HotelAttributeResponse, Error>({
        path: `/hotel-attributes/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-attribute
     * @name DeleteHotelAttributesId
     * @request DELETE:/hotel-attributes/{id}
     * @secure
     */
    deleteHotelAttributesId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/hotel-attributes/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-attribute
     * @name PostHotelAttributesIdLocalizations
     * @request POST:/hotel-attributes/{id}/localizations
     * @secure
     */
    postHotelAttributesIdLocalizations: (
      id: number,
      data: HotelAttributeLocalizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<HotelAttributeLocalizationResponse, Error>({
        path: `/hotel-attributes/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  hotelAttributeGroups = {
    /**
     * No description
     *
     * @tags Hotel-attribute-group
     * @name GetHotelAttributeGroups
     * @request GET:/hotel-attribute-groups
     * @secure
     */
    getHotelAttributeGroups: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HotelAttributeGroupListResponse, Error>({
        path: `/hotel-attribute-groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-attribute-group
     * @name PostHotelAttributeGroups
     * @request POST:/hotel-attribute-groups
     * @secure
     */
    postHotelAttributeGroups: (data: HotelAttributeGroupRequest, params: RequestParams = {}) =>
      this.request<HotelAttributeGroupResponse, Error>({
        path: `/hotel-attribute-groups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-attribute-group
     * @name GetHotelAttributeGroupsId
     * @request GET:/hotel-attribute-groups/{id}
     * @secure
     */
    getHotelAttributeGroupsId: (id: number, params: RequestParams = {}) =>
      this.request<HotelAttributeGroupResponse, Error>({
        path: `/hotel-attribute-groups/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-attribute-group
     * @name PutHotelAttributeGroupsId
     * @request PUT:/hotel-attribute-groups/{id}
     * @secure
     */
    putHotelAttributeGroupsId: (id: number, data: HotelAttributeGroupRequest, params: RequestParams = {}) =>
      this.request<HotelAttributeGroupResponse, Error>({
        path: `/hotel-attribute-groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-attribute-group
     * @name DeleteHotelAttributeGroupsId
     * @request DELETE:/hotel-attribute-groups/{id}
     * @secure
     */
    deleteHotelAttributeGroupsId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/hotel-attribute-groups/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-attribute-group
     * @name PostHotelAttributeGroupsIdLocalizations
     * @request POST:/hotel-attribute-groups/{id}/localizations
     * @secure
     */
    postHotelAttributeGroupsIdLocalizations: (
      id: number,
      data: HotelAttributeGroupLocalizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<HotelAttributeGroupLocalizationResponse, Error>({
        path: `/hotel-attribute-groups/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  hotelUnits = {
    /**
     * No description
     *
     * @tags Hotel-unit
     * @name GetHotelUnits
     * @request GET:/hotel-units
     * @secure
     */
    getHotelUnits: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HotelUnitListResponse, Error>({
        path: `/hotel-units`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit
     * @name PostHotelUnits
     * @request POST:/hotel-units
     * @secure
     */
    postHotelUnits: (data: HotelUnitRequest, params: RequestParams = {}) =>
      this.request<HotelUnitResponse, Error>({
        path: `/hotel-units`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit
     * @name GetHotelUnitsId
     * @request GET:/hotel-units/{id}
     * @secure
     */
    getHotelUnitsId: (id: number, params: RequestParams = {}) =>
      this.request<HotelUnitResponse, Error>({
        path: `/hotel-units/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit
     * @name PutHotelUnitsId
     * @request PUT:/hotel-units/{id}
     * @secure
     */
    putHotelUnitsId: (id: number, data: HotelUnitRequest, params: RequestParams = {}) =>
      this.request<HotelUnitResponse, Error>({
        path: `/hotel-units/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit
     * @name DeleteHotelUnitsId
     * @request DELETE:/hotel-units/{id}
     * @secure
     */
    deleteHotelUnitsId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/hotel-units/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit
     * @name PostHotelUnitsIdLocalizations
     * @request POST:/hotel-units/{id}/localizations
     * @secure
     */
    postHotelUnitsIdLocalizations: (id: number, data: HotelUnitLocalizationRequest, params: RequestParams = {}) =>
      this.request<HotelUnitLocalizationResponse, Error>({
        path: `/hotel-units/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  hotelUnitGroups = {
    /**
     * No description
     *
     * @tags Hotel-unit-group
     * @name GetHotelUnitGroups
     * @request GET:/hotel-unit-groups
     * @secure
     */
    getHotelUnitGroups: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HotelUnitGroupListResponse, Error>({
        path: `/hotel-unit-groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group
     * @name PostHotelUnitGroups
     * @request POST:/hotel-unit-groups
     * @secure
     */
    postHotelUnitGroups: (data: HotelUnitGroupRequest, params: RequestParams = {}) =>
      this.request<HotelUnitGroupResponse, Error>({
        path: `/hotel-unit-groups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group
     * @name GetHotelUnitGroupsId
     * @request GET:/hotel-unit-groups/{id}
     * @secure
     */
    getHotelUnitGroupsId: (id: number, params: RequestParams = {}) =>
      this.request<HotelUnitGroupResponse, Error>({
        path: `/hotel-unit-groups/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group
     * @name PutHotelUnitGroupsId
     * @request PUT:/hotel-unit-groups/{id}
     * @secure
     */
    putHotelUnitGroupsId: (id: number, data: HotelUnitGroupRequest, params: RequestParams = {}) =>
      this.request<HotelUnitGroupResponse, Error>({
        path: `/hotel-unit-groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group
     * @name DeleteHotelUnitGroupsId
     * @request DELETE:/hotel-unit-groups/{id}
     * @secure
     */
    deleteHotelUnitGroupsId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/hotel-unit-groups/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group
     * @name PostHotelUnitGroupsIdLocalizations
     * @request POST:/hotel-unit-groups/{id}/localizations
     * @secure
     */
    postHotelUnitGroupsIdLocalizations: (
      id: number,
      data: HotelUnitGroupLocalizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<HotelUnitGroupLocalizationResponse, Error>({
        path: `/hotel-unit-groups/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  hotelUnitGroupAttributes = {
    /**
     * No description
     *
     * @tags Hotel-unit-group-attribute
     * @name GetHotelUnitGroupAttributes
     * @request GET:/hotel-unit-group-attributes
     * @secure
     */
    getHotelUnitGroupAttributes: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HotelUnitGroupAttributeListResponse, Error>({
        path: `/hotel-unit-group-attributes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-attribute
     * @name PostHotelUnitGroupAttributes
     * @request POST:/hotel-unit-group-attributes
     * @secure
     */
    postHotelUnitGroupAttributes: (data: HotelUnitGroupAttributeRequest, params: RequestParams = {}) =>
      this.request<HotelUnitGroupAttributeResponse, Error>({
        path: `/hotel-unit-group-attributes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-attribute
     * @name GetHotelUnitGroupAttributesId
     * @request GET:/hotel-unit-group-attributes/{id}
     * @secure
     */
    getHotelUnitGroupAttributesId: (id: number, params: RequestParams = {}) =>
      this.request<HotelUnitGroupAttributeResponse, Error>({
        path: `/hotel-unit-group-attributes/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-attribute
     * @name PutHotelUnitGroupAttributesId
     * @request PUT:/hotel-unit-group-attributes/{id}
     * @secure
     */
    putHotelUnitGroupAttributesId: (id: number, data: HotelUnitGroupAttributeRequest, params: RequestParams = {}) =>
      this.request<HotelUnitGroupAttributeResponse, Error>({
        path: `/hotel-unit-group-attributes/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-attribute
     * @name DeleteHotelUnitGroupAttributesId
     * @request DELETE:/hotel-unit-group-attributes/{id}
     * @secure
     */
    deleteHotelUnitGroupAttributesId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/hotel-unit-group-attributes/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-attribute
     * @name PostHotelUnitGroupAttributesIdLocalizations
     * @request POST:/hotel-unit-group-attributes/{id}/localizations
     * @secure
     */
    postHotelUnitGroupAttributesIdLocalizations: (
      id: number,
      data: HotelUnitGroupAttributeLocalizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<HotelUnitGroupAttributeLocalizationResponse, Error>({
        path: `/hotel-unit-group-attributes/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  hotelUnitGroupAttributeGroups = {
    /**
     * No description
     *
     * @tags Hotel-unit-group-attribute-group
     * @name GetHotelUnitGroupAttributeGroups
     * @request GET:/hotel-unit-group-attribute-groups
     * @secure
     */
    getHotelUnitGroupAttributeGroups: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HotelUnitGroupAttributeGroupListResponse, Error>({
        path: `/hotel-unit-group-attribute-groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-attribute-group
     * @name PostHotelUnitGroupAttributeGroups
     * @request POST:/hotel-unit-group-attribute-groups
     * @secure
     */
    postHotelUnitGroupAttributeGroups: (data: HotelUnitGroupAttributeGroupRequest, params: RequestParams = {}) =>
      this.request<HotelUnitGroupAttributeGroupResponse, Error>({
        path: `/hotel-unit-group-attribute-groups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-attribute-group
     * @name GetHotelUnitGroupAttributeGroupsId
     * @request GET:/hotel-unit-group-attribute-groups/{id}
     * @secure
     */
    getHotelUnitGroupAttributeGroupsId: (id: number, params: RequestParams = {}) =>
      this.request<HotelUnitGroupAttributeGroupResponse, Error>({
        path: `/hotel-unit-group-attribute-groups/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-attribute-group
     * @name PutHotelUnitGroupAttributeGroupsId
     * @request PUT:/hotel-unit-group-attribute-groups/{id}
     * @secure
     */
    putHotelUnitGroupAttributeGroupsId: (
      id: number,
      data: HotelUnitGroupAttributeGroupRequest,
      params: RequestParams = {},
    ) =>
      this.request<HotelUnitGroupAttributeGroupResponse, Error>({
        path: `/hotel-unit-group-attribute-groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-attribute-group
     * @name DeleteHotelUnitGroupAttributeGroupsId
     * @request DELETE:/hotel-unit-group-attribute-groups/{id}
     * @secure
     */
    deleteHotelUnitGroupAttributeGroupsId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/hotel-unit-group-attribute-groups/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-attribute-group
     * @name PostHotelUnitGroupAttributeGroupsIdLocalizations
     * @request POST:/hotel-unit-group-attribute-groups/{id}/localizations
     * @secure
     */
    postHotelUnitGroupAttributeGroupsIdLocalizations: (
      id: number,
      data: HotelUnitGroupAttributeGroupLocalizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<HotelUnitGroupAttributeGroupLocalizationResponse, Error>({
        path: `/hotel-unit-group-attribute-groups/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  hotelUnitGroupPromotionLabels = {
    /**
     * No description
     *
     * @tags Hotel-unit-group-promotion-label
     * @name GetHotelUnitGroupPromotionLabels
     * @request GET:/hotel-unit-group-promotion-labels
     * @secure
     */
    getHotelUnitGroupPromotionLabels: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HotelUnitGroupPromotionLabelListResponse, Error>({
        path: `/hotel-unit-group-promotion-labels`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-promotion-label
     * @name PostHotelUnitGroupPromotionLabels
     * @request POST:/hotel-unit-group-promotion-labels
     * @secure
     */
    postHotelUnitGroupPromotionLabels: (data: HotelUnitGroupPromotionLabelRequest, params: RequestParams = {}) =>
      this.request<HotelUnitGroupPromotionLabelResponse, Error>({
        path: `/hotel-unit-group-promotion-labels`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-promotion-label
     * @name GetHotelUnitGroupPromotionLabelsId
     * @request GET:/hotel-unit-group-promotion-labels/{id}
     * @secure
     */
    getHotelUnitGroupPromotionLabelsId: (id: number, params: RequestParams = {}) =>
      this.request<HotelUnitGroupPromotionLabelResponse, Error>({
        path: `/hotel-unit-group-promotion-labels/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-promotion-label
     * @name PutHotelUnitGroupPromotionLabelsId
     * @request PUT:/hotel-unit-group-promotion-labels/{id}
     * @secure
     */
    putHotelUnitGroupPromotionLabelsId: (
      id: number,
      data: HotelUnitGroupPromotionLabelRequest,
      params: RequestParams = {},
    ) =>
      this.request<HotelUnitGroupPromotionLabelResponse, Error>({
        path: `/hotel-unit-group-promotion-labels/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-promotion-label
     * @name DeleteHotelUnitGroupPromotionLabelsId
     * @request DELETE:/hotel-unit-group-promotion-labels/{id}
     * @secure
     */
    deleteHotelUnitGroupPromotionLabelsId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/hotel-unit-group-promotion-labels/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-promotion-label
     * @name PostHotelUnitGroupPromotionLabelsIdLocalizations
     * @request POST:/hotel-unit-group-promotion-labels/{id}/localizations
     * @secure
     */
    postHotelUnitGroupPromotionLabelsIdLocalizations: (
      id: number,
      data: HotelUnitGroupPromotionLabelLocalizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<HotelUnitGroupPromotionLabelLocalizationResponse, Error>({
        path: `/hotel-unit-group-promotion-labels/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  hotelUnitGroupViewTypes = {
    /**
     * No description
     *
     * @tags Hotel-unit-group-view-type
     * @name GetHotelUnitGroupViewTypes
     * @request GET:/hotel-unit-group-view-types
     * @secure
     */
    getHotelUnitGroupViewTypes: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HotelUnitGroupViewTypeListResponse, Error>({
        path: `/hotel-unit-group-view-types`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-view-type
     * @name PostHotelUnitGroupViewTypes
     * @request POST:/hotel-unit-group-view-types
     * @secure
     */
    postHotelUnitGroupViewTypes: (data: HotelUnitGroupViewTypeRequest, params: RequestParams = {}) =>
      this.request<HotelUnitGroupViewTypeResponse, Error>({
        path: `/hotel-unit-group-view-types`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-view-type
     * @name GetHotelUnitGroupViewTypesId
     * @request GET:/hotel-unit-group-view-types/{id}
     * @secure
     */
    getHotelUnitGroupViewTypesId: (id: number, params: RequestParams = {}) =>
      this.request<HotelUnitGroupViewTypeResponse, Error>({
        path: `/hotel-unit-group-view-types/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-view-type
     * @name PutHotelUnitGroupViewTypesId
     * @request PUT:/hotel-unit-group-view-types/{id}
     * @secure
     */
    putHotelUnitGroupViewTypesId: (id: number, data: HotelUnitGroupViewTypeRequest, params: RequestParams = {}) =>
      this.request<HotelUnitGroupViewTypeResponse, Error>({
        path: `/hotel-unit-group-view-types/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-view-type
     * @name DeleteHotelUnitGroupViewTypesId
     * @request DELETE:/hotel-unit-group-view-types/{id}
     * @secure
     */
    deleteHotelUnitGroupViewTypesId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/hotel-unit-group-view-types/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hotel-unit-group-view-type
     * @name PostHotelUnitGroupViewTypesIdLocalizations
     * @request POST:/hotel-unit-group-view-types/{id}/localizations
     * @secure
     */
    postHotelUnitGroupViewTypesIdLocalizations: (
      id: number,
      data: HotelUnitGroupViewTypeLocalizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<HotelUnitGroupViewTypeLocalizationResponse, Error>({
        path: `/hotel-unit-group-view-types/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  incomingRequests = {
    /**
     * No description
     *
     * @tags Incoming-request
     * @name GetIncomingRequests
     * @request GET:/incoming-requests
     * @secure
     */
    getIncomingRequests: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<IncomingRequestListResponse, Error>({
        path: `/incoming-requests`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Incoming-request
     * @name PostIncomingRequests
     * @request POST:/incoming-requests
     * @secure
     */
    postIncomingRequests: (data: IncomingRequestRequest, params: RequestParams = {}) =>
      this.request<IncomingRequestResponse, Error>({
        path: `/incoming-requests`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Incoming-request
     * @name GetIncomingRequestsId
     * @request GET:/incoming-requests/{id}
     * @secure
     */
    getIncomingRequestsId: (id: number, params: RequestParams = {}) =>
      this.request<IncomingRequestResponse, Error>({
        path: `/incoming-requests/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Incoming-request
     * @name PutIncomingRequestsId
     * @request PUT:/incoming-requests/{id}
     * @secure
     */
    putIncomingRequestsId: (id: number, data: IncomingRequestRequest, params: RequestParams = {}) =>
      this.request<IncomingRequestResponse, Error>({
        path: `/incoming-requests/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Incoming-request
     * @name DeleteIncomingRequestsId
     * @request DELETE:/incoming-requests/{id}
     * @secure
     */
    deleteIncomingRequestsId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/incoming-requests/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  landingPages = {
    /**
     * No description
     *
     * @tags Landing-page
     * @name GetLandingPages
     * @request GET:/landing-pages
     * @secure
     */
    getLandingPages: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LandingPageListResponse, Error>({
        path: `/landing-pages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Landing-page
     * @name PostLandingPages
     * @request POST:/landing-pages
     * @secure
     */
    postLandingPages: (data: LandingPageRequest, params: RequestParams = {}) =>
      this.request<LandingPageResponse, Error>({
        path: `/landing-pages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Landing-page
     * @name GetLandingPagesId
     * @request GET:/landing-pages/{id}
     * @secure
     */
    getLandingPagesId: (id: number, params: RequestParams = {}) =>
      this.request<LandingPageResponse, Error>({
        path: `/landing-pages/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Landing-page
     * @name PutLandingPagesId
     * @request PUT:/landing-pages/{id}
     * @secure
     */
    putLandingPagesId: (id: number, data: LandingPageRequest, params: RequestParams = {}) =>
      this.request<LandingPageResponse, Error>({
        path: `/landing-pages/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Landing-page
     * @name DeleteLandingPagesId
     * @request DELETE:/landing-pages/{id}
     * @secure
     */
    deleteLandingPagesId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/landing-pages/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Landing-page
     * @name PostLandingPagesIdLocalizations
     * @request POST:/landing-pages/{id}/localizations
     * @secure
     */
    postLandingPagesIdLocalizations: (id: number, data: LandingPageLocalizationRequest, params: RequestParams = {}) =>
      this.request<LandingPageLocalizationResponse, Error>({
        path: `/landing-pages/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  ownerUnitCreationRequests = {
    /**
     * No description
     *
     * @tags Owner-unit-creation-request
     * @name GetOwnerUnitCreationRequests
     * @request GET:/owner-unit-creation-requests
     * @secure
     */
    getOwnerUnitCreationRequests: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OwnerUnitCreationRequestListResponse, Error>({
        path: `/owner-unit-creation-requests`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner-unit-creation-request
     * @name PostOwnerUnitCreationRequests
     * @request POST:/owner-unit-creation-requests
     * @secure
     */
    postOwnerUnitCreationRequests: (data: OwnerUnitCreationRequestRequest, params: RequestParams = {}) =>
      this.request<OwnerUnitCreationRequestResponse, Error>({
        path: `/owner-unit-creation-requests`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner-unit-creation-request
     * @name GetOwnerUnitCreationRequestsId
     * @request GET:/owner-unit-creation-requests/{id}
     * @secure
     */
    getOwnerUnitCreationRequestsId: (id: number, params: RequestParams = {}) =>
      this.request<OwnerUnitCreationRequestResponse, Error>({
        path: `/owner-unit-creation-requests/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner-unit-creation-request
     * @name PutOwnerUnitCreationRequestsId
     * @request PUT:/owner-unit-creation-requests/{id}
     * @secure
     */
    putOwnerUnitCreationRequestsId: (id: number, data: OwnerUnitCreationRequestRequest, params: RequestParams = {}) =>
      this.request<OwnerUnitCreationRequestResponse, Error>({
        path: `/owner-unit-creation-requests/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner-unit-creation-request
     * @name DeleteOwnerUnitCreationRequestsId
     * @request DELETE:/owner-unit-creation-requests/{id}
     * @secure
     */
    deleteOwnerUnitCreationRequestsId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/owner-unit-creation-requests/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  ownerUnitCreationRequestMedias = {
    /**
     * No description
     *
     * @tags Owner-unit-creation-request-media
     * @name GetOwnerUnitCreationRequestMedias
     * @request GET:/owner-unit-creation-request-medias
     * @secure
     */
    getOwnerUnitCreationRequestMedias: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OwnerUnitCreationRequestMediaListResponse, Error>({
        path: `/owner-unit-creation-request-medias`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner-unit-creation-request-media
     * @name PostOwnerUnitCreationRequestMedias
     * @request POST:/owner-unit-creation-request-medias
     * @secure
     */
    postOwnerUnitCreationRequestMedias: (data: OwnerUnitCreationRequestMediaRequest, params: RequestParams = {}) =>
      this.request<OwnerUnitCreationRequestMediaResponse, Error>({
        path: `/owner-unit-creation-request-medias`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner-unit-creation-request-media
     * @name GetOwnerUnitCreationRequestMediasId
     * @request GET:/owner-unit-creation-request-medias/{id}
     * @secure
     */
    getOwnerUnitCreationRequestMediasId: (id: number, params: RequestParams = {}) =>
      this.request<OwnerUnitCreationRequestMediaResponse, Error>({
        path: `/owner-unit-creation-request-medias/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner-unit-creation-request-media
     * @name PutOwnerUnitCreationRequestMediasId
     * @request PUT:/owner-unit-creation-request-medias/{id}
     * @secure
     */
    putOwnerUnitCreationRequestMediasId: (
      id: number,
      data: OwnerUnitCreationRequestMediaRequest,
      params: RequestParams = {},
    ) =>
      this.request<OwnerUnitCreationRequestMediaResponse, Error>({
        path: `/owner-unit-creation-request-medias/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner-unit-creation-request-media
     * @name DeleteOwnerUnitCreationRequestMediasId
     * @request DELETE:/owner-unit-creation-request-medias/{id}
     * @secure
     */
    deleteOwnerUnitCreationRequestMediasId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/owner-unit-creation-request-medias/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  plainTextPages = {
    /**
     * No description
     *
     * @tags Plain-text-page
     * @name GetPlainTextPages
     * @request GET:/plain-text-pages
     * @secure
     */
    getPlainTextPages: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PlainTextPageListResponse, Error>({
        path: `/plain-text-pages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plain-text-page
     * @name PostPlainTextPages
     * @request POST:/plain-text-pages
     * @secure
     */
    postPlainTextPages: (data: PlainTextPageRequest, params: RequestParams = {}) =>
      this.request<PlainTextPageResponse, Error>({
        path: `/plain-text-pages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plain-text-page
     * @name GetPlainTextPagesId
     * @request GET:/plain-text-pages/{id}
     * @secure
     */
    getPlainTextPagesId: (id: number, params: RequestParams = {}) =>
      this.request<PlainTextPageResponse, Error>({
        path: `/plain-text-pages/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plain-text-page
     * @name PutPlainTextPagesId
     * @request PUT:/plain-text-pages/{id}
     * @secure
     */
    putPlainTextPagesId: (id: number, data: PlainTextPageRequest, params: RequestParams = {}) =>
      this.request<PlainTextPageResponse, Error>({
        path: `/plain-text-pages/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plain-text-page
     * @name DeletePlainTextPagesId
     * @request DELETE:/plain-text-pages/{id}
     * @secure
     */
    deletePlainTextPagesId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/plain-text-pages/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plain-text-page
     * @name PostPlainTextPagesIdLocalizations
     * @request POST:/plain-text-pages/{id}/localizations
     * @secure
     */
    postPlainTextPagesIdLocalizations: (
      id: number,
      data: PlainTextPageLocalizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<PlainTextPageLocalizationResponse, Error>({
        path: `/plain-text-pages/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  promotionLabels = {
    /**
     * No description
     *
     * @tags Promotion-label
     * @name GetPromotionLabels
     * @request GET:/promotion-labels
     * @secure
     */
    getPromotionLabels: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PromotionLabelListResponse, Error>({
        path: `/promotion-labels`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion-label
     * @name PostPromotionLabels
     * @request POST:/promotion-labels
     * @secure
     */
    postPromotionLabels: (data: PromotionLabelRequest, params: RequestParams = {}) =>
      this.request<PromotionLabelResponse, Error>({
        path: `/promotion-labels`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion-label
     * @name GetPromotionLabelsId
     * @request GET:/promotion-labels/{id}
     * @secure
     */
    getPromotionLabelsId: (id: number, params: RequestParams = {}) =>
      this.request<PromotionLabelResponse, Error>({
        path: `/promotion-labels/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion-label
     * @name PutPromotionLabelsId
     * @request PUT:/promotion-labels/{id}
     * @secure
     */
    putPromotionLabelsId: (id: number, data: PromotionLabelRequest, params: RequestParams = {}) =>
      this.request<PromotionLabelResponse, Error>({
        path: `/promotion-labels/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion-label
     * @name DeletePromotionLabelsId
     * @request DELETE:/promotion-labels/{id}
     * @secure
     */
    deletePromotionLabelsId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/promotion-labels/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion-label
     * @name PostPromotionLabelsIdLocalizations
     * @request POST:/promotion-labels/{id}/localizations
     * @secure
     */
    postPromotionLabelsIdLocalizations: (
      id: number,
      data: PromotionLabelLocalizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<PromotionLabelLocalizationResponse, Error>({
        path: `/promotion-labels/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  regions = {
    /**
     * No description
     *
     * @tags Region
     * @name GetRegions
     * @request GET:/regions
     * @secure
     */
    getRegions: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RegionListResponse, Error>({
        path: `/regions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Region
     * @name PostRegions
     * @request POST:/regions
     * @secure
     */
    postRegions: (data: RegionRequest, params: RequestParams = {}) =>
      this.request<RegionResponse, Error>({
        path: `/regions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Region
     * @name GetRegionsId
     * @request GET:/regions/{id}
     * @secure
     */
    getRegionsId: (id: number, params: RequestParams = {}) =>
      this.request<RegionResponse, Error>({
        path: `/regions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Region
     * @name PutRegionsId
     * @request PUT:/regions/{id}
     * @secure
     */
    putRegionsId: (id: number, data: RegionRequest, params: RequestParams = {}) =>
      this.request<RegionResponse, Error>({
        path: `/regions/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Region
     * @name DeleteRegionsId
     * @request DELETE:/regions/{id}
     * @secure
     */
    deleteRegionsId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/regions/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Region
     * @name PostRegionsIdLocalizations
     * @request POST:/regions/{id}/localizations
     * @secure
     */
    postRegionsIdLocalizations: (id: number, data: RegionLocalizationRequest, params: RequestParams = {}) =>
      this.request<RegionLocalizationResponse, Error>({
        path: `/regions/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  restaurants = {
    /**
     * No description
     *
     * @tags Restaurant
     * @name GetRestaurants
     * @request GET:/restaurants
     * @secure
     */
    getRestaurants: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RestaurantListResponse, Error>({
        path: `/restaurants`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Restaurant
     * @name PostRestaurants
     * @request POST:/restaurants
     * @secure
     */
    postRestaurants: (data: RestaurantRequest, params: RequestParams = {}) =>
      this.request<RestaurantResponse, Error>({
        path: `/restaurants`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Restaurant
     * @name GetRestaurantsId
     * @request GET:/restaurants/{id}
     * @secure
     */
    getRestaurantsId: (id: number, params: RequestParams = {}) =>
      this.request<RestaurantResponse, Error>({
        path: `/restaurants/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Restaurant
     * @name PutRestaurantsId
     * @request PUT:/restaurants/{id}
     * @secure
     */
    putRestaurantsId: (id: number, data: RestaurantRequest, params: RequestParams = {}) =>
      this.request<RestaurantResponse, Error>({
        path: `/restaurants/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Restaurant
     * @name DeleteRestaurantsId
     * @request DELETE:/restaurants/{id}
     * @secure
     */
    deleteRestaurantsId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/restaurants/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Restaurant
     * @name PostRestaurantsIdLocalizations
     * @request POST:/restaurants/{id}/localizations
     * @secure
     */
    postRestaurantsIdLocalizations: (id: number, data: RestaurantLocalizationRequest, params: RequestParams = {}) =>
      this.request<RestaurantLocalizationResponse, Error>({
        path: `/restaurants/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  seos = {
    /**
     * No description
     *
     * @tags Seo
     * @name GetSeos
     * @request GET:/seos
     * @secure
     */
    getSeos: (
      query?: {
        /** Sort by attributes ascending (asc) or descending (desc) */
        sort?: string;
        /** Return page/pageSize (default: true) */
        "pagination[withCount]"?: boolean;
        /** Page number (default: 0) */
        "pagination[page]"?: number;
        /** Page size (default: 25) */
        "pagination[pageSize]"?: number;
        /** Offset value (default: 0) */
        "pagination[start]"?: number;
        /** Number of entities to return (default: 25) */
        "pagination[limit]"?: number;
        /** Fields to return (ex: title,author) */
        fields?: string;
        /** Relations to return */
        populate?: string;
        /** Filters to apply */
        filters?: object;
        /** Locale to apply */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SeoListResponse, Error>({
        path: `/seos`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seo
     * @name PostSeos
     * @request POST:/seos
     * @secure
     */
    postSeos: (data: SeoRequest, params: RequestParams = {}) =>
      this.request<SeoResponse, Error>({
        path: `/seos`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seo
     * @name GetSeosId
     * @request GET:/seos/{id}
     * @secure
     */
    getSeosId: (id: number, params: RequestParams = {}) =>
      this.request<SeoResponse, Error>({
        path: `/seos/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seo
     * @name PutSeosId
     * @request PUT:/seos/{id}
     * @secure
     */
    putSeosId: (id: number, data: SeoRequest, params: RequestParams = {}) =>
      this.request<SeoResponse, Error>({
        path: `/seos/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seo
     * @name DeleteSeosId
     * @request DELETE:/seos/{id}
     * @secure
     */
    deleteSeosId: (id: number, params: RequestParams = {}) =>
      this.request<number, Error>({
        path: `/seos/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seo
     * @name PostSeosIdLocalizations
     * @request POST:/seos/{id}/localizations
     * @secure
     */
    postSeosIdLocalizations: (id: number, data: SeoLocalizationRequest, params: RequestParams = {}) =>
      this.request<SeoLocalizationResponse, Error>({
        path: `/seos/${id}/localizations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
